<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 mb-4">
        <template v-if="oldEvaluationWorks && (oldEvaluationWorks.doc_number || oldEvaluationWorks.owner)">
          <div class="mb-4">
            <div class="section-header font-weight-bold old-evaluation-works-collapse" v-b-toggle.old-evaluation-works>
              <h4>
                <i class="fa fa-arrow-down"></i>
                Олдин бахоланганлар
                <span class="badge badge-warning d-inline-flex align-items-center justify-content-center m-1">{{ oldEvaluationWorks.doc_number.length + oldEvaluationWorks.owner.length }}</span>
              </h4>
            </div>
            <b-collapse id="old-evaluation-works" accordion="old-evaluation-works" role="tabpanel">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-4" v-for="oldWork in oldEvaluationWorks.doc_number" :key="'work_' + oldWork.id">
                  <div class="alert alert-secondary alert-dismissible fade show alert-wrap" role="alert">
                    <a class="alert-heading" v-if="!oldWork.assetId" :href="oldWork.url + `/new-real-estate/edit/${oldWork.id}`" target="_blank">#{{oldWork.id}}  {{oldWork.name}}</a>
                    <a class="alert-heading" v-else-if="oldWork.assetId" :href="oldWork.url + `/asset/new-real-estate/edit/${oldWork.id}`" target="_blank">Аралаш мол-мулк#{{oldWork.assetId}}  {{oldWork.name}}</a>
                    <p class="font-weight-bold pl-3 mt-1">{{oldWork.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</p>
                    <p class="alert-item mb-0"> Бахоланган сана
                      <span v-if="oldWork.confirmedDate">{{oldWork.confirmedDate}} </span>
                      <span v-else>{{new Date(oldWork.createdDate) | dateFormat('DD/MM/YYYY hh:mm')}}</span>
                    </p>
                    <p class="alert-item mb-0">Бахолаш мақсади <span class="badge badge-pill badge-warning" v-if="oldWork.evlGoalTypeDto">{{oldWork.evlGoalTypeDto.typeName}} </span></p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="section-header">
                    <h4>Мулк эгаси буйича</h4>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-4" v-for="oldWork in oldEvaluationWorks.owner" :key="'work_' + oldWork.id">
                  <div class="alert alert-secondary alert-dismissible fade show alert-wrap" role="alert">
                    <a class="alert-heading" v-if="!oldWork.assetId" :href="oldWork.url + `/new-real-estate/edit/${oldWork.id}`" target="_blank">#{{oldWork.id}}  {{oldWork.name}}</a>
                    <a class="alert-heading" v-else-if="oldWork.assetId" :href="oldWork.url + `/asset/new-real-estate/edit/${oldWork.id}`" target="_blank">Аралаш мол-мулк#{{oldWork.assetId}}  {{oldWork.name}}</a>
                    <p class="font-weight-bold pl-3 mt-1">{{oldWork.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</p>
                    <p class="alert-item mb-0"> Бахоланган сана
                      <span v-if="oldWork.confirmedDate">{{oldWork.confirmedDate}} </span>
                      <span v-else>{{new Date(oldWork.createdDate) | dateFormat('DD/MM/YYYY hh:mm')}}</span>
                    </p>
                    <p class="alert-item mb-0">Бахолаш мақсади <span class="badge badge-pill badge-warning" v-if="oldWork.evlGoalTypeDto">{{oldWork.evlGoalTypeDto.typeName}} </span></p>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </template>
        <StepProgress :wizardSection="realEstate.wizardSection" :realEstate="realEstate"></StepProgress>
      </div>
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left" v-if="realEstate.id">
                    {{ $t("realEstate.edit.title") }}
                    ({{
                      $t(realEstate.category === 'Residential' ?
                          'realEstate.category.residential.label' :
                          'realEstate.category.notorious.label')
                    }})</h4>
                  <h4 class="card-title float-left" v-else>{{ $t("realEstate.add.title") }}
                    ({{
                      $t(realEstate.category === 'Residential' ?
                          'realEstate.category.residential.label' :
                          'realEstate.category.notorious.label')
                    }})</h4>
                </div>
                <button class="all-btn add-btn pull-right"
                        v-if="realEstate.id && realEstate.id > 0 && canSendAgent && isEditable"
                        @click="showBindAgentModal">Агентни узгартириш
                </button>
                <button class="all-btn add-btn pull-right"
                        v-if="canFireBaseSendMassage"
                        :disabled="loadFireBase"
                        @click="sendMessageFromAndroid">
                  <i class="fa fa-file-text" v-if="!loadFireBase"></i>
                  <i v-if="loadFireBase" class="fa fa-spinner fa-spin"></i>
                  <span> Мобил илова орқали маълумот олиш</span>
                </button>
                <router-link tag="button" :to="`/real-estate-evaluation/edit/${realEstate.id}`"
                             v-if="isEvaluationForItem"
                             class="all-btn pull-right">
                  <i class="fa fa-forward"></i><span>Литр</span>
                </router-link>
              </div>
            </div>
            <div class="row" v-if="realEstate.status === 'Rejected'">
              <div class="col">
                <div class="alert alert-danger">
                  <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..<span>{{ realEstate.reasonDesc }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div :class="{invalid: $v.buildingType.code.$error}" v-if="isUserAppraiser">
                      <div class="form-group">
                        <label>{{$t("newRealEstate.field.plus.buildingType")}} <span class="red">*</span></label>
                        <v-select v-model="buildingType" label="name"
                                  :options="buildingTypes"
                                  :filterable="false"
                                  @search:focus="onBuildingFocus"
                                  @search="onBuildingTypeSearch"
                                  @change="onChangeBuildingType"
                                  :disabled="!canShowForAllSpecialUsers"
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.name">
                            <div v-html="option.name"></div>
                          </template>
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                      </div>
                    </div>
                    <div v-if="!isMultiStorey && !isResidential && !canShowForAllSpecialUsers" :class="{invalid: $v.subBuildingType.code.$error}">
                      <div class="form-group">
                        <label>{{$t("newRealEstate.field.plus.subBuildingType")}} <span class="red">*</span></label>
                        <v-select v-model="subBuildingType" label="name"
                                  :options="subBuildingTypes"
                                  :filterable="false"
                                  @search="subBuildingTypeSearch"
                                  @search:focus="subBuildingTypeFocus"
                                  :disabled="!canChangeSubBuildingType"
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.name">
                            <div v-html="option.name"></div>
                          </template>
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                      </div>
                    </div>

                    <template v-if="hasPermission('REAL_ESTATE_VIEW_FULL_DATA')">
                      <div :class="{invalid: $v.realEstate.mfy.$error}" v-if="!isUserSpecial">
                        <div class="form-group">
                          <label>{{$t("newRealEstate.field.plus.mfy")}} <span class="red">*</span></label>
                          <v-select v-model="realEstate.mfy" label="name"
                                    :options="mfyList"
                                    :filterable="false"
                                    @search:focus="mfyFocus"
                                    :disabled="true"
                          >
                            <template slot="option" slot-scope="option" v-if="option && option.name">
                              <div v-html="option.name"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-check pl-0">
                          <label class="form-check-label" style="padding-left:22px !important">
                            <input type="checkbox"
                                   class="form-check-input"
                                   v-model="realEstate.isMicroRegionSelected"
                                   @change="handleChangeMicroRegionSelected"
                            >
                            <span class="form-check-sign"></span>
                            <span class="text-uppercase">{{$t("newRealEstate.field.plus.microRegionSelected")}}</span>
                          </label>
                        </div>
                      </div>
                      <div class="form-group" v-if="isMicroRegionSelected">
                        <label>{{$t("realEstate.field.microRegion")}} <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="realEstate.microRegionId"
                                :class="{invalid: $v.realEstate.microRegionId.$error}"
                        >
                          <option value=""></option>
                          <option :value="option.id" v-for="option in microRegions" :key="option.id">
                            {{option.name}}
                          </option>
                        </select>
                      </div>
                    </template>

                    <template v-for="(field, index) in cadastreBuildingFields">
                      <div class="form-group" :key="field.code" v-if="isLeftCustomField(field) && canShowFieldInMultiStoreyForSpecialUSer(field.code) && showFieldForSpecialUser(field.code)">
                        <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                        <template v-if="field.type === 'TEXT'">
                          <input type="text" class="form-control" v-model="field.value"
                                 :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'INTEGER'">
                          <numeric-input v-model="field.value"
                                         :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'DECIMAL'">
                          <numeric-input v-model="field.value" :precision="2"
                                         :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'LISTBOX'">
                          <select
                              class="form-control"
                              v-model="field.value"
                              :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                              @change="onFieldValueChange(field)"
                              :disabled="isLeftFieldDisabled(field.code)"
                          >
                            <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                          </select>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'COMBOBOX'">
                          <v-select v-model="field.selected" label="name"
                                    :options="cadastreBuildingFieldReferences[field.reference.code]"
                                    :filterable="false"
                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'MULTISELECT'">
                          <treeselect
                              class="form-control"
                              v-model="field.selected"
                              :multiple="true"
                              placeholder="Танланг..."
                              :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                              :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                              @input="onFieldValueChange(field)"
                              :disabled="isLeftFieldDisabled(field.code)"
                          ></treeselect>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'DATE_PICKER'">
                          <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                      </div>
                    </template>

                    <div class="form-group" v-if="!isUserSpecial">
                      <div class="row">
                        <div class="col-12">
                          <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                        </div>
                        <div class="col-12">
                          <div :class="{invalid : $v.realEstate.approach.$error}" class="d-flex flex-column">
                            <div class="form-check pl-0 checkbox-inline" v-if="isApproachCost">
                              <label class="form-check-label pl-4">
                                <input class="form-check-input" type="checkbox"
                                       v-model="realEstate.approachCost"
                                       :disabled="!isUserSpecial2"
                                >
                                <span class="form-check-sign"></span>
                                {{$t("realEstate.approach.expense")}}
                              </label>
                            </div>
                            <div class="form-check pl-0 checkbox-inline">
                              <label class="form-check-label pl-4">
                                <input class="form-check-input" type="checkbox"
                                       v-model="realEstate.approachIncome"
                                       :disabled="isUserSpecial2 ? isNoChangeIncome : true"
                                >
                                <span class="form-check-sign"></span>
                                {{$t("realEstate.approach.income")}}
                              </label>
                            </div>
                            <div class="form-check pl-0 checkbox-inline">
                              <label class="form-check-label pl-4">
                                <input class="form-check-input" type="checkbox"
                                       v-model="realEstate.approachComparative"
                                       :disabled="!isUserSpecial2"
                                >
                                <span class="form-check-sign"></span>
                                {{$t("realEstate.approach.comparative")}}
                              </label>
                            </div>
                          </div>
                          <div class="red" v-if="$v.realEstate.approach.$error">
                            {{$t("realEstate.validation.approachMethods")}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div :class="{invalid: $v.wall.code.$error}" v-if="!isUserSpecial">
                      <div class="form-group">
                        <label>{{$t("realEstate.field.constructiveElement")}} <span class="red">*</span></label>
                        <v-select v-model="wall" label="displayName"
                                  :options="walls"
                                  :filterable="false"
                                  @search:focus="onConstructiveElementFocus"
                                  :disabled="!isUserSpecial2" readonly
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.displayName">
                            <div v-html="option.displayName"></div>
                          </template>
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                      </div>
                    </div>
                    <div class="red" v-if="$v.wall.code.$error">{{$t('newRealEstate.validation.wall')}}</div>

                    <div class="form-group" v-if="!isMultiStorey && !isUserSpecial">
                      <div class="form-check pl-0">
                        <label class="form-check-label" style="padding-left:22px !important">
                          <input type="checkbox"
                                 class="form-check-input"
                                 v-model="realEstate.separateBuilding"
                                 :disabled="!isUserSpecial2"
                          >
                          <span class="form-check-sign"></span>
                          {{$t("realEstate.field.separateBuilding")}}
                        </label>
                      </div>
                    </div>

                    <div class="form-group" v-if="canShowFieldForSpecialUser">
                      <label>{{$t('realEstate.field.storey')}}</label>
                      <select class="form-control"
                              v-model="realEstate.storey"
                              :class="{invalid: $v.realEstate.storey.$error}"
                              :disabled="canShowFieldForSpecialUser"
                      >
                        <option :value="option.value"
                                v-for="option in ref.storeys"
                                :key="option.label">{{option.label}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-if="!isSeparateBuilding && canShowFieldForSpecialUser">
                      <label>{{$t('realEstate.field.floor')}}</label>
                      <select class="form-control"
                              v-model="realEstate.floor"
                              :class="{invalid: $v.realEstate.floor.$error}"
                              :disabled="canShowFieldForSpecialUser"
                      >
                        <option :value="option.value"
                                v-for="option in ref.floors"
                                :key="option.label">{{option.label}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group" v-if="!canShowForAllSpecialUsers">
                      <label>{{$t("realEstate.field.constructionCompletion")}} <span class="red">*</span></label>
                      <numeric-input v-model="realEstate.constructionCompletion" :max="100" :precision="2" disabled readonly></numeric-input>
                      <div class="red" v-if="$v.realEstate.constructionCompletion.$error">{{$t("newRealEstate.validation.constructionCompletion")}}</div>
                    </div>

                  </div>

                  <div class="col-12 col-md-6">
                    <div :class="{invalid: $v.architecturalStyle.code.$error}" v-if="!isUserSpecial">
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.architecturalStyle") }} <span class="red">*</span></label>
                        <v-select v-model="architecturalStyle" label="displayName"
                                  :options="architecturalStyles"
                                  :filterable="false"
                                  @search:focus="onArchitecturalStyleFocus"
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.displayName">
                            <div v-html="option.displayName"></div>
                          </template>
                          <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                        </v-select>
                      </div>
                      <div class="red" v-if="$v.architecturalStyle.code.$error">{{$t('newRealEstate.validation.architecturalStyle')}}</div>
                    </div>

                    <div :class="{invalid: $v.repairCondition.code.$error}" v-if="!isUserSpecial">
                      <div class="form-group">
                        <label>{{$t("realEstate.field.repairConditions")}} <span class="red">*</span></label>
                        <v-select v-model="repairCondition" label="displayName"
                                  :options="repairConditions"
                                  :filterable="false"
                                  @search:focus="onRepairFocus"
                                  @change="onRepairChange"
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.displayName">
                            <div v-html="option.displayName"></div>
                          </template>
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                      </div>
                      <div class="red" v-if="$v.repairCondition.code.$error">{{$t('newRealEstate.validation.repairCondition')}}</div>
                    </div>

                    <template v-for="(field, index) in cadastreBuildingFields">
                      <div class="form-group" :key="field.code" v-if="isRightCustomField(field) && showFieldForSpecialUser(field.code)">
                        <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                        <template v-if="field.type === 'TEXT'">
                          <input type="text" class="form-control" v-model="field.value"
                                 :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'INTEGER'">
                          <numeric-input v-model="field.value"
                                         :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)" :disabled="isRightFieldDisabled(field.code)"></numeric-input>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'DECIMAL'">
                          <numeric-input v-model="field.value" :precision="2"
                                         :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)" :disabled="isRightFieldDisabled(field.code)"></numeric-input>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'LISTBOX'">
                          <select class="form-control" v-model="field.value"
                                  :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)" :disabled="isRightFieldDisabled(field.code)">
                            <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                          </select>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'COMBOBOX'">
                          <v-select v-model="field.selected" label="name"
                                    :options="cadastreBuildingFieldReferences[field.reference.code]"
                                    :filterable="false"
                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)" :disabled="isRightFieldDisabled(field.code)">
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'MULTISELECT'">
                          <treeselect class="form-control" v-model="field.selected" :multiple="true"
                                      placeholder="Танланг..."
                                      :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @input="onFieldValueChange(field)" :disabled="isRightFieldDisabled(field.code)">
                          </treeselect>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                        <template v-else-if="field.type === 'DATE_PICKER'">
                          <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                          <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                        </template>
                      </div>
                    </template>

                    <div :class="{invalid: $v.specialComfort.code.$error}">
                      <div class="form-group">
                        <label>{{$t("realEstate.field.specialComfort")}} <span class="red">*</span></label>
                        <v-select v-model="specialComfort" label="displayName"
                                  :options="specialComforts"
                                  :filterable="false"
                                  @search:focus="onSpecialComfortFocus"
                        >
                          <template slot="option" slot-scope="option" v-if="option && option.displayName">
                            <div v-html="option.displayName"></div>
                          </template>
                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                      </div>
                    </div>

                    <div class="form-group" v-if="!canShowForAllSpecialUsers">
                      <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                          class="red">*</span></label>
                      <select class="form-control"
                              v-model="realEstate.evlGoalType"
                              :class="{invalid : $v.realEstate.evlGoalType.$error}"
                      >
                        <option :value="option.code" v-for="option in goalTypes" :key="option.key">
                          {{option.typeName}}
                        </option>
                      </select>
                      <div class="red" v-if="$v.realEstate.evlGoalType.$error">
                        {{$t("realEstate.validation.evaluationPurpose")}}
                      </div>
                    </div>

                    <div class="form-group" v-if="hasPermission('REAL_ESTATE_ASSIGN') && this.realEstate.status != 'SentToComplement'">
                      <label>{{$t("realEstate.field.evaluator")}}</label>
                      <select class="form-control" v-model="realEstate.employee.id"
                              :class="{invalid: $v.realEstate.employee.$error}">
                        <option value=""></option>
                        <option :value="option.id" v-for="option in employees" :key="option.id">
                          {{option.name}}
                        </option>
                      </select>
                      <div class="red" v-if="$v.realEstate.employee.$error">
                        {{$t("realEstate.validation.evaluator")}}
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <b-form-group
                    v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                      v-model="selectedRealEstateDocsTab"
                      :options="[
                                { text: 'Бино расмлари', value: 'images' },
                                { text: 'Хужжатлар', value: 'docs' }
                      ]"
                      :aria-describedby="ariaDescribedby"
                      button-variant="form-radio-group"
                      name="radio-btn-outline1"
                      buttons
                  ></b-form-radio-group>
                </b-form-group>

                <div v-if="selectedRealEstateDocsTab === 'images'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in realEstateAllPhotos" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'" class="docs-image-wrapper">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                        <button class="image-download-btn all-btn add-btn" @click="handleDownloadImage(photo.filePath, photo.orgName)" v-tooltip="'Расмни юклаб олиш'">
                          <i class="fa fa-download"></i>
                        </button>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%" style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

                <div v-if="selectedRealEstateDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in realEstateDocs" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%" style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

              </div>

              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12" v-if="realEstate.hasCustomer">
                    <div class="form-group">
                      <label>{{$t("realEstate.field.withLetterOfAttorneyOwner")}} <span
                          class="red">*</span></label>
                      <v-select v-model="realEstate.customer" label="text"
                                :options="customers"
                                :filterable="false"
                                @search="onCustomerSearch"
                                @search:focus="onCustomerFocus"
                                :class="{invalid : $v.realEstate.customer.$error}"
                                :disabled="canShowForAllSpecialUsers"
                      >
                        <template slot="option" slot-scope="option" v-if="option && option.text">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="realEstate && realEstate.customer && realEstate.customer.text">
                          <div v-html="realEstate.customer.text"></div>
                        </template>
                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                      </v-select>
                      <div class="red" v-if="$v.realEstate.customer.$error">
                        {{$t("realEstate.validation.withLetterOfAttorneyOwner")}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6" v-if="realEstate.hasCustomer && !canShowForAllSpecialUsers">
                    <div class="form-group">
                      <label>{{$t('realEstate.field.powerOfAttorneyNumber')}} <span class="red">*</span></label>
                      <input type="text"
                             class="form-control"
                             v-model="realEstate.powerOfAttorneyNumber"
                             :class="{invalid: $v.realEstate.powerOfAttorneyNumber.$error}"
                             :disabled="canShowForAllSpecialUsers"
                      >
                    </div>
                    <div class="form-group">
                      <label>{{$t('realEstate.field.powerOfAttorneyDate')}} <span class="red">*</span></label>
                      <datepicker class="form-control custom-zoom" format="dd/MM/yyyy"
                                  v-model="powerOfAttorneyDate"
                                  :clear-button="!canShowForAllSpecialUsers"
                                  :class="{invalid : $v.powerOfAttorneyDate.$error}"
                                  :disabled="canShowForAllSpecialUsers"
                      ></datepicker>
                    </div>
                  </div>
                  <div class="col-12 col-md-6" v-if="!canShowForAllSpecialUsers">
                    <div class="form-group">
                      <label>{{$t("realEstate.field.contractAmount")}}</label>
                      <numeric-input class="form-control" v-model="realEstate.evlContractAmount"
                                     :disabled="(isOwnerTypeLegal && isOrgTypeMib) || isPaid || realEstate.status == 'SentToComplement'"
                                     v-if="!isOnlineAndApi"
                                     :controls="false" :precision="2"></numeric-input>
                      <span class="form-control" v-else>{{realEstate.evlContractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                      <textarea type="text" class="form-control" v-model="realEstate.evaluatorIdea"></textarea>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>Чекловчи шартлар</label>
                      <textarea type="text" class="form-control" v-model="realEstate.evaluatorTerms"></textarea>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row" v-if="showReportButton">
              <div class="col-12 btns-box">
                <button class="btn btn-primary pull-right mr-2 btn-sm"
                        @click="reportNotSignedAndNoQrCodesPdf(realEstate)"
                        v-if="hasPermission('REAL_ESTATE_NO_SIGNED_REPORT_PDF')"
                >
                  <i v-if="isOtherPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.reportNotSignedAndNoQrCodesPdf") }}
                </button>
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('REAL_ESTATE_REPORT_WORD')"
                    @click="reportDocQrCode(realEstate)">
                  <i v-if="isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWordQrCode") }}
                </button>
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('REAL_ESTATE_REPORT_WORD')"
                    @click="reportDoc(realEstate)">
                  <i v-if="isDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWord") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_REPORT_PDF_QR_CODE')"
                        @click="reportPdfQrCode(realEstate)">
                  <i v-if="isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_REPORT_PDF')"
                        @click="reportPdf(realEstate)">
                  <i v-if="isPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.title") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_CONTRACT_PDF_QR_CODE')"
                        @click="reportContractQrCodePdf(realEstate)">
                  <i v-if="isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdfQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_CONTRACT_PDF')"
                        @click="reportContractPdf(realEstate)">
                  <i v-if="isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdf") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_CONTRACT_WORD')"
                        @click="reportContractDocQrCode(realEstate)">
                  <i v-if="isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWordQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('REAL_ESTATE_CONTRACT_WORD')"
                        @click="reportContractDoc(realEstate)">
                  <i v-if="isCDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWord") }}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group" v-if="!initLoading">
                  <label>{{ $t("realEstate.field.locationText") }}</label>
                  <real-estate-location-map :realEstateId="realEstate.id" :marker="false" :height="320"/>
                </div>
              </div>
            </div>

            <div role="tablist" v-if="hasPermission('REAL_ESTATE_VIEW_FULL_DATA')">
              <div class="row mt-4">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.header-1 v-tooltip="'Кўчмас мулк асосий маълумотлари очиш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{$t("realEstate.field.basicInformation")}}
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="header-1" accordion="evl-accordion" role="tabpanel" v-model="realEstateVisible">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>{{$t("realEstate.field.evaluationRespectiveType")}} <span
                                  class="red">*</span></label>
                          <select class="form-control" v-model="realEstate.evaluationRespectiveType"
                                  :class="{invalid : $v.realEstate.evaluationRespectiveType.$error}" :disabled="canShowForAllSpecialUsers">
                            <option :value="option.code" v-for="option in evaluationRespectiveTypes" :key="option.code">
                              {{option.displayName}}
                            </option>
                          </select>
                          <div class="red" v-if="$v.realEstate.evaluationRespectiveType.$error">
                            {{$t("realEstate.validation.evaluationRespectiveType")}}
                          </div>
                        </div>
                        <div class="form-row" v-if="isTenders">
                          <div class="form-group col-md-4">
                            <label>
                              {{$t("realEstate.field.tenderContractDate")}} <span class="red">*</span>
                            </label>
                            <custom-date-picker
                                    class="form-control"
                                    format="dd/MM/yyyy"
                                    v-model="realEstate.tenderContractDate"
                                    :date="realEstate.tenderContractDate"
                                    :clear-button="!canShowForAllSpecialUsers"
                                    :class="{invalid:$v.realEstate.tenderContractDate.$error}"
                                    :disabled="canShowForAllSpecialUsers"
                            ></custom-date-picker>
                          </div>
                          <div class="form-group col-md-3">
                            <label>
                              {{$t("realEstate.field.tenderContractNumber")}} <span class="red">*</span>
                            </label>
                            <input type="text" class="form-control"
                                   :class="{invalid: $v.realEstate.tenderContractNumber.$error}"
                                   :disabled="canShowForAllSpecialUsers"
                                   v-model="realEstate.tenderContractNumber">
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                          <v-select v-model="realEstate.owner" label="text"
                                    :options="owners"
                                    :filterable="false"
                                    @search="onOwnerSearch"
                                    @search:focus="onOwnerFocus"
                                    :class="{invalid : $v.realEstate.owner.$error}"
                                    :disabled="canShowForAllSpecialUsers"
                          >
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.text"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="realEstate && realEstate.owner && realEstate.owner.text">
                              <div v-html="realEstate.owner.text"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                          <div class="red" v-if="$v.realEstate.owner.$error">
                            {{$t("realEstate.validation.ownerClient")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="form-check pl-0">
                            <label class="form-check-label" style="padding-left:22px !important">
                              <input class="form-check-input" type="checkbox"
                                     v-model="realEstate.hasCustomer" :disabled="canShowForAllSpecialUsers">
                              <span class="form-check-sign"></span>
                              {{$t("realEstate.field.withLetterOfAttorney")}}
                            </label>
                          </div>
                        </div>
                        <template v-if="realEstate.hasCustomer">
                          <div class="form-group">
                            <label>{{$t("realEstate.field.withLetterOfAttorneyOwner")}} <span
                                    class="red">*</span></label>
                            <v-select v-model="realEstate.customer" label="text"
                                      :options="customers"
                                      :filterable="false"
                                      @search="onCustomerSearch"
                                      @search:focus="onCustomerFocus"
                                      :class="{invalid : $v.realEstate.customer.$error}"
                                      :disabled="canShowForAllSpecialUsers"
                            >
                              <template slot="option" slot-scope="option" v-if="option && option.text">
                                <div v-html="option.text"></div>
                              </template>
                              <template slot="selected-option"
                                        v-if="realEstate && realEstate.customer && realEstate.customer.text">
                                <div v-html="realEstate.customer.text"></div>
                              </template>
                              <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                            </v-select>
                            <div class="red" v-if="$v.realEstate.customer.$error">
                              {{$t("realEstate.validation.withLetterOfAttorneyOwner")}}
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{$t('realEstate.field.powerOfAttorneyNumber')}} <span class="red">*</span></label>
                            <input type="text"
                                   class="form-control"
                                   v-model="realEstate.powerOfAttorneyNumber"
                                   :class="{invalid: $v.realEstate.powerOfAttorneyNumber.$error}"
                                   :disabled="canShowForAllSpecialUsers"
                            >
                          </div>
                          <div class="form-group">
                            <label>{{$t('realEstate.field.powerOfAttorneyDate')}} <span class="red">*</span></label>
                            <datepicker class="form-control custom-zoom" format="dd/MM/yyyy"
                                        v-model="powerOfAttorneyDate"
                                        :clear-button="!canShowForAllSpecialUsers"
                                        :class="{invalid : $v.powerOfAttorneyDate.$error}"
                                        :disabled="canShowForAllSpecialUsers"
                            ></datepicker>
                          </div>
                        </template>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-12">
                              <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                            </div>
                            <div class="col-12">
                              <div :class="{invalid : $v.realEstate.approach.$error}">
                                <div class="form-check pl-0 checkbox-inline" v-if="isApproachCost">
                                  <label class="form-check-label"
                                         style="padding-left:22px !important">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="realEstate.approachCost"
                                           :disabled="canShowForAllSpecialUsers"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("realEstate.approach.expense")}}
                                  </label>
                                </div>
                                <div class="form-check checkbox-inline">
                                  <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="realEstate.approachIncome"
                                           :disabled="isNoChangeIncome || canShowForAllSpecialUsers"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("realEstate.approach.income")}}
                                  </label>
                                </div>
                                <div class="form-check checkbox-inline">
                                  <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="realEstate.approachComparative"
                                           :disabled="canShowForAllSpecialUsers"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("realEstate.approach.comparative")}}
                                  </label>
                                </div>
                              </div>
                              <div class="red" v-if="$v.realEstate.approach.$error">
                                {{$t("realEstate.validation.approachMethods")}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                  class="red">*</span></label>
                          <select class="form-control"
                                  v-model="realEstate.evlGoalType"
                                  :class="{invalid : $v.realEstate.evlGoalType.$error}"
                                  :disabled="canShowForAllSpecialUsers"
                          >
                            <option :value="option.code" v-for="option in goalTypes" :key="option.key">
                              {{option.typeName}}
                            </option>
                          </select>
                          <div class="red" v-if="$v.realEstate.evlGoalType.$error">
                            {{$t("realEstate.validation.evaluationPurpose")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                          <input type="text" class="form-control" v-model="realEstate.name" disabled readonly>
                        </div>
                        <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*</span></label>
                        <div class="input-group mb-2">
                          <cadastre-input :cadastre-number.sync="realEstate.cadastreDocNumber"
                                          :invalid="$v.realEstate.cadastreDocNumber.$error"
                                          :disabled="isOnlineAndApi || canShowForAllSpecialUsers"
                                          :readonly="isOnlineAndApi"
                          />
                          <div v-if="canSave" class="input-group-append">
                            <button class="all-btn search-btn" type="button"
                                    :disabled="realEstate.wizardSection > 1 || !hasPermission('REAL_ESTATE_PLUS_CADASTER_API') || loadCadastreDoc"
                                    @click="searchCadastre"
                            >Маълумотни олиш</button>
                          </div>
                          <div class="red" v-if="$v.realEstate.cadastreDocNumber.$error">
                            {{$t("realEstate.validation.cadastreNumber")}}
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Кадастр ёки баланс қиймати <span class="red">*</span></label>
                          <numeric-input
                                  v-model="realEstate.cadastreBalance"
                                  :precision="2" align="right"
                                  :class="{invalid : $v.realEstate.cadastreBalance.$error}"
                                  :disabled="true"
                                  :readonly="true"
                          ></numeric-input>
                          <div class="red" v-if="$v.realEstate.cadastreBalance.$error">{{$t("building.validation.cadastreBalance")}}</div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                          <v-select
                                  label="name"
                                  v-model="realEstate.province"
                                  :filterable="false"
                                  :options="provinces"
                                  @search="onProvinceSearch"
                                  @search:focus="onProvinceFocus"
                                  :class="{invalid : $v.realEstate.province.id.$error}"
                                  @change="onProvinceChange"
                                  disabled readonly
                          >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                          <div class="red" v-if="$v.realEstate.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.region")}} <span class="red">*</span></label>
                          <v-select
                                  label="name"
                                  v-model="realEstate.region"
                                  :filterable="false"
                                  :options="regions"
                                  @search="onRegionSearch"
                                  @search:focus="onRegionFocus"
                                  :class="{invalid : $v.realEstate.region.id.$error}"
                                  @change="onRegionChange"
                                  disabled readonly
                          >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                          </v-select>
                          <div class="red" v-if="$v.realEstate.region.id.$error">
                            {{$t("realEstate.validation.region")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.addressAddEdit")}} <span class="red">*</span></label>
                          <input type="text" class="form-control" v-model="realEstate.address"
                                 :class="{invalid : $v.realEstate.address.$error}"/>
                          <div class="red" v-if="$v.realEstate.address.$error">
                            {{$t("realEstate.validation.addressAddEdit")}}
                          </div>
                        </div>
                        <template v-if="isOrgTypeMib">
                          <div class="form-group">
                            <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                    class="red">*</span></label>
                            <input type="text" class="form-control" v-model="realEstate.mibDebtorName"
                                   :class="{invalid : $v.realEstate.mibDebtorName.$error}"
                                   :disabled="canShowForAllSpecialUsers"
                            />
                            <div class="red" v-if="$v.realEstate.mibDebtorName.$error">
                              {{$t("realEstate.validation.mibDebtorName")}}
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                    class="red">*</span></label>
                            <input type="text" class="form-control" v-model="realEstate.mibLetterNumber"
                                   :class="{invalid : $v.realEstate.mibLetterNumber.$error}" disabled readonly/>
                            <div class="red" v-if="$v.realEstate.mibLetterNumber.$error">
                              {{$t("realEstate.validation.mibLetterNumber")}}
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                    class="red">*</span></label>
                            <datepicker class="form-control" format="dd/MM/yyyy" v-model="mibLetterDate"
                                        :clear-button="false"
                                        :class="{invalid : $v.mibLetterDate.$error}" :disabled="true"></datepicker>
                            <div class="red" v-if="$v.mibLetterDate.$error">
                              {{$t("realEstate.validation.mibLetterDate")}}
                            </div>
                          </div>
                        </template>
                        <div :class="{invalid: $v.wall.code.$error}">
                          <div class="form-group">
                            <label>{{$t("realEstate.field.constructiveElement")}} <span class="red">*</span></label>
                            <v-select v-model="wall" label="displayName"
                                      :options="walls"
                                      :filterable="false"
                                      @search:focus="onConstructiveElementFocus"
                                      disabled readonly
                            >
                              <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                <div v-html="option.displayName"></div>
                              </template>
                              <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                            </v-select>
                          </div>
                        </div>
                        <div class="red" v-if="$v.wall.code.$error">{{$t('newRealEstate.validation.wall')}}</div>

                        <div :class="{invalid: $v.specialComfort.code.$error}">
                          <div class="form-group">
                            <label>{{$t("realEstate.field.specialComfort")}} <span class="red">*</span></label>
                            <v-select v-model="specialComfort" label="displayName"
                                      :options="specialComforts"
                                      :filterable="false"
                                      @search:focus="onSpecialComfortFocus"
                                      :disabled="canShowForAllSpecialUsers"
                            >
                              <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                <div v-html="option.displayName"></div>
                              </template>
                              <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                            </v-select>
                          </div>
                        </div>
                        <div class="form-group" v-if="realEstate.borrower">
                          <label>Қарз олувчи</label>
                          <span class="form-control">{{ realEstate.borrower.borrowerName ? realEstate.borrower.borrowerName : realEstate.borrower.borrowerName}}</span>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>{{$t("realEstate.field.areaTotal")}} <span class="red">*</span></label>
                          <numeric-input v-model="realEstate.evlGroundArea" :precision="2" disabled readonly></numeric-input>
                          <!--<div class="red" v-if="$v.realEstate.evlGroundArea.$error">-->
                          <!--{{$t("realEstate.validation.areaTotal")}}-->
                          <!--</div>-->
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.areaUnderConstruction")}} <span
                                  class="red">*</span></label>
                          <numeric-input v-model="realEstate.evlBuildingWidthArea"
                                         :precision="2"
                                         :class="{invalid : $v.realEstate.evlBuildingWidthArea.$error}"
                                         disabled readonly
                          ></numeric-input>
                          <div class="red" v-if="$v.realEstate.evlBuildingWidthArea.$error">
                            {{$t("realEstate.validation.areaUnderConstruction")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.areaUseful")}} <span class="red">*</span></label>
                          <numeric-input v-model="realEstate.evlUsefulField" :precision="2"
                                         :class="{invalid : $v.realEstate.evlUsefulField.$error}"
                                         disabled readonly
                          ></numeric-input>
                          <div class="red" v-if="$v.realEstate.evlUsefulField.$error">
                            {{$t("realEstate.validation.areaUseful")}}
                          </div>
                        </div>
                        <div class="form-row align-items-center">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  {{$t("realEstate.field.evlTotalArea")}} <span v-if="hasTotalArea" class="red">*</span>
                                </label>
                                <numeric-input v-model="realEstate.evlTotalArea" :precision="2"
                                               :class="{invalid : $v.realEstate.evlTotalArea.$error}"
                                               :disabled="canShowForAllSpecialUsers"
                                ></numeric-input>
                                <div class="red" v-if="$v.realEstate.evlTotalArea.$error">
                                  {{$t("realEstate.validation.evlTotalArea")}}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <div class="form-check pl-0">
                                  <label class="form-check-label text-uppercase" style="padding-left:22px !important">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="realEstate.hasTotalArea"
                                           :disabled="canShowForAllSpecialUsers"
                                    >
                                    <span class="form-check-sign"></span>
                                    {{$t("realEstate.field.hasTotalArea")}}
                                  </label>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="!isMultiStorey">
                          <div class="form-check pl-0">
                            <label class="form-check-label" style="padding-left:22px !important">
                              <input type="checkbox"
                                     class="form-check-input"
                                     v-model="realEstate.separateBuilding"
                                     :disabled="canShowForAllSpecialUsers"
                              >
                              <span class="form-check-sign"></span>
                              {{$t("realEstate.field.separateBuilding")}}
                            </label>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t('realEstate.field.storey')}}</label>
                          <select class="form-control"
                                  v-model="realEstate.storey"
                                  @input="onChangeStorey"
                                  :class="{invalid: $v.realEstate.storey.$error}"
                                  :disabled="canShowForAllSpecialUsers"
                          >
                            <option :value="option.value"
                                    v-for="option in ref.storeys"
                                    :key="option.label">{{option.label}}
                            </option>
                          </select>
                          <!-- <numeric-input v-model="realEstate.storey" :precision="0"
                                          :formatType="'String'"
                                          :class="{invalid: $v.realEstate.storey.$error}"
                                          @input="onChangeStorey"
                           ></numeric-input> -->
                        </div>
                        <div class="form-group" v-if="!isSeparateBuilding">
                          <label>{{$t('realEstate.field.floor')}}</label>
                          <select class="form-control"
                                  v-model="realEstate.floor"
                                  :class="{invalid: $v.realEstate.floor.$error}"
                                  :disabled="canShowForAllSpecialUsers"
                          >
                            <option :value="option.value"
                                    v-for="option in ref.floors"
                                    :key="option.label">{{option.label}}
                            </option>
                          </select>
                          <!-- <numeric-input v-model="realEstate.floor" :precision="0"
                                         :formatType="'String'"
                                         :class="{invalid: $v.realEstate.floor.$error}"
                          ></numeric-input> -->
                        </div>

                        <div class="form-group">
                          <label>{{$t('realEstate.field.builtYear')}}</label>
                          <numeric-input
                                  v-model="realEstate.builtYear"
                                  :precision="0"
                                  :max="maxMadeYear"
                                  disabled readonly
                                  :class="{invalid: $v.realEstate.builtYear.$error}"
                          >
                          </numeric-input>
                        </div>

                        <div class="form-group">
                          <label>{{$t("realEstate.field.constructionCompletion")}} <span class="red">*</span></label>
                          <numeric-input v-model="realEstate.constructionCompletion" :max="100" :precision="2" @change="onChangeConstructionCompletion" disabled readonly></numeric-input>
                          <div class="red" v-if="$v.realEstate.constructionCompletion.$error">{{$t("newRealEstate.validation.constructionCompletion")}}</div>
                        </div>
                        <div class="form-group" v-if="hasPermission('REAL_ESTATE_ASSIGN') && this.realEstate.status != 'SentToComplement'">
                          <label>{{$t("realEstate.field.evaluator")}}</label>
                          <select class="form-control" v-model="realEstate.employee.id"
                                  :class="{invalid: $v.realEstate.employee.$error}">
                            <option value=""></option>
                            <option :value="option.id" v-for="option in employees" :key="option.id">
                              {{option.name}}
                            </option>
                          </select>
                          <div class="red" v-if="$v.realEstate.employee.$error">
                            {{$t("realEstate.validation.evaluator")}}
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="form-check checkbox-inline">
                            <label class="form-check-label pl-0">
                              <input class="form-check-input" type="checkbox"
                                     v-model="realEstate.lightConstructiveElement"
                                     :disabled="!hasPermission('REAL_ESTATE_LIGHT_CONSTRUCTIVE_ELEMENT') || canShowForAllSpecialUsers"
                                     name="contractAmountByAgreement" readonly>
                              <span class="form-check-sign"></span>
                              Енгил конструктив элемент
                            </label>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.contractAmount")}}</label>
                          <numeric-input class="form-control" v-model="realEstate.evlContractAmount"
                                         :disabled="(isOwnerTypeLegal && isOrgTypeMib) || isPaid || realEstate.status == 'SentToComplement' || canShowForAllSpecialUsers"
                                         v-if="!isOnlineAndApi"
                                         :controls="false" :precision="2"></numeric-input>
                          <span class="form-control" v-else>{{realEstate.evlContractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                        </div>
                        <div class="form-group">
                          <div v-if="isOwnerTypeLegal && !isOrgTypeMib">
                            <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                            <numeric-input class="form-control" v-model="realEstate.prepayment"
                                           :controls="false" :precision="2" :disabled="true" :readonly="true"></numeric-input>
                          </div>
                          <div class="form-group"><span>ҚҚС билан: {{realEstate.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span></div>
                          <div class="form-group"><span>Туланган сумма: {{realEstate.paidAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span></div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-12">
                              <label>{{$t("realEstate.field.valueType")}} <span
                                      class="red">*</span></label>
                            </div>
                            <div class="col-12" :class="{invalid : $v.realEstate.evlValueType.$error}">
                              <div class="form-check form-check-radio checkbox-inline pl-0"
                                   style="margin-left:-0.8rem">
                                <label class="form-check-label">
                                  <input class="form-check-input" type="radio" name="evlValueType"
                                         value="Market" v-model="realEstate.evlValueType"
                                         :disabled="canShowForAllSpecialUsers"
                                  >
                                  <span class="form-check-sign"></span>
                                  {{$t("realEstate.valueType.market")}}
                                </label>
                              </div>
                              <div class="form-check form-check-radio checkbox-inline">
                                <label class="form-check-label">
                                  <input class="form-check-input" type="radio" name="evlValueType"
                                         value="NonMarket" v-model="realEstate.evlValueType"
                                         :disabled="canShowForAllSpecialUsers"
                                  >
                                  <span class="form-check-sign"></span>
                                  {{$t("realEstate.valueType.nonMarket")}}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="red" v-if="$v.realEstate.evlValueType.$error">
                            {{$t("realEstate.validation.valueType")}}
                          </div>
                        </div>
                        <div v-if="realEstate.evlValueType === 'NonMarket'">
                          <template v-for="(field, index) in cadastreBuildingFields">
                            <div class="form-group" :key="field.code" v-if="field.code === 'non_market_type'">
                              <label>{{field.name}} <span class="red">*</span></label>
                              <select class="form-control" v-model="field.value"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                      @change="onFieldValueChange(field)"
                                      :disabled="canShowForAllSpecialUsers"
                              >
                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">
                                  {{option.name}}
                                </option>
                              </select>
                              <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </div>
                          </template>
                        </div>
                        <div class="form-group">
                          <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                          <select class="form-control" v-model="realEstate.evlPropertyType"
                                  :class="{invalid : $v.realEstate.evlPropertyType.$error}"
                                  :disabled="canShowForAllSpecialUsers"
                          >
                            <option value=""></option>
                            <option :value="option.code" v-for="option in propertyTypes" :key="option.code">
                              {{option.name}}
                            </option>
                          </select>
                          <div class="red" v-if="$v.realEstate.evlPropertyType.$error">
                            {{$t("realEstate.validation.propertyType")}}
                          </div>
                        </div>
                        <template>
                          <template v-for="(field, index) in cadastreBuildingFields">
                            <div class="form-group" :key="field.code" v-if="!isMultiStorey && !isResidential && field.code === 'land_fund_category'">
                              <label>{{field.name}} <span class="red">*</span></label>
                              <select class="form-control" v-model="field.value"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                      @change="onFieldValueChange(field)"
                                      :disabled="isUserSpecial"
                              >
                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">
                                  {{option.name}}
                                </option>
                              </select>
                              <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </div>
                            <div class="form-group" :key="field.code" v-if="field.code === 'land_owner_right'">
                              <label>{{field.name}} <span class="red">*</span></label>
                              <select class="form-control" v-model="field.value"
                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}"
                                      @change="onFieldValueChange(field)"
                                      :disabled="canShowForAllSpecialUsers"
                              >
                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">
                                  {{option.name}}
                                </option>
                              </select>
                              <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                            </div>
                          </template>
                          <template v-if="realEstate.landLeaseEnabled && realEstate.landLeaseData">
                            <div class="table-responsive mt-3">
                              <div class="table-wrapper">
                                <table class="table table-sm table-striped">
                                  <thead>
                                  <th width="20%" class="text-center"><label>Жойлашган жойи</label></th>
                                  <th width="10%" class="text-center"><label>Зона</label></th>
                                  <th width="15%" class="text-center"><label>1 кв.м ижара сўммаси</label></th>
                                  <th width="25%" class="text-center"><label>Ер участкаси майдони кв.м</label></th>
                                  <th class="text-center"><label>Ер участкаси якуний қиймати (сўм)</label></th>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <td class="text-left">{{realEstate.province.name}}, {{realEstate.region.name}}</td>
                                    <td class="text-center">{{realEstate.landLeaseData.zone}}</td>
                                    <td class="text-right">{{realEstate.landLeaseData.rentAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td class="text-center">{{realEstate.landLeaseData.area}}</td>
                                    <td class="text-right">{{realEstate.landLeaseData.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </template>
                          <div class="form-group">
                            <div class="form-check checkbox-inline">
                              <label class="form-check-label pl-0">
                                <input class="form-check-input" type="checkbox"
                                       v-model="realEstate.fixByIndex"
                                       name="isFixByIndexComparative"
                                       :disabled="canShowForAllSpecialUsers"
                                >
                                <span class="form-check-sign"></span>
                                {{$t("realEstate.field.isFixByIndexLabel")}}
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <button class="all-btn add-btn"
                                        v-if="hasPermission('NEW_REAL_ESTATE_EDIT')"
                                        @click="viewRealEstateAct(realEstate.id)"
                                >
                                  <i class="fa fa-list"></i>
                                  <span>Акт маълумотларини киритиш</span>
                                </button>
                              </div>
                            </div>
                            <div class="col-md-8">
                              <div class="form-group">
                                <button class="all-btn view-btn"
                                        @click="viewRealEstateSurvey(realEstate)"
                                >
                                  <i class="fa fa-list"></i>
                                  <span>Сўровнома маълумотлари</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div v-if="isSourceInside" class="row">
                      <div class="col-12" >
                        <div class="section-header font-weight-bold" style="cursor: pointer;">
                          <div block v-b-toggle.docsToSubmit>
                            <h4>
                              <i class="fa fa-arrow-down"></i>
                              {{$t("realEstate.field.docsToSubmit")}}
                            </h4>
                          </div>
                        </div>
                        <div class="col-12" v-if="!loadEdit">
                          <RealEstateDropZone code="realEstatePhotoDropZone"
                                              folder="Building"
                                              label="building.field.photosToSubmit"
                                              acceptedFiles="image/*"
                                              view="BUILDING" :data="realEstate.photos"
                                              @change="(photos) => {realEstate.photos = photos}"
                                              :removeFile="canRemoveFile"
                                              :editable="canSave"
                                              :has-error="$v.realEstate.photos.$error"
                          />
                        </div>
                        <div v-if="realEstate.id && realEstate.id > 0">
                          <template>
                            <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                             :data="realEstate.checkPaymentFiles"
                                             @change="(files) => {realEstate.checkPaymentFiles = files}"
                            />
                            <!-- :has-error="$v.realEstate.balance.$error"-->
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="form-check checkbox-inline">
                      <label class="form-check-label pl-3 font-weight-bold">
                        <input class="form-check-input" type="checkbox"
                               v-model="realEstate.displayReport"
                               @change="showReport()"
                               v-bind:disabled="!hasPermission('REAL_ESTATE_DISPLAY_REPORT') || canShowForAllSpecialUsers"
                        >
                        <span class="form-check-sign"></span>
                        {{$t("report.field.showReport")}}
                      </label>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="row" v-if="!isUserSpecial">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.land-comparison v-tooltip="$t('newRealEstate.field.plus.landComparison')">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{ $t("newRealEstate.field.plus.landComparison") }}
                        <b class="ml-4" v-if="realEstate.landComparisonEnabled">
                          <span v-if="realEstate.newLandComparison">{{realEstate.newLandComparison.calculatedTotalPrice | currency('', 2, {thousandsSeparator: ' '})}} сўм</span>
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="land-comparison" accordion="evl-accordion" role="tabpanel">
                    <NewLandPlusCalculationView v-if="!initLoading" :landResult="realEstate.newLandComparison" />
                  </b-collapse>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.approach-cost v-tooltip="$t('realEstate.approach.expense')">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{ $t("realEstate.approach.expense") }}
                        <b class="ml-4" v-if="realEstate.approachCost">
                          <span v-if="realEstate.coordination && realEstate.coordination.expense && realEstate.coordination.expense.amount">{{realEstate.coordination.expense.amount | currency('', 2, {thousandsSeparator: ' '})}} сўм</span>
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="approach-cost" accordion="evl-accordion" role="tabpanel">
                    <div class="row" v-if="realEstate.id && realEstate.id > 0">
                      <div class="col-md-8">
                        <div :class="{invalid : $v.realEstate.sections.$error}">
                          <div class="form-group" v-if="realEstate.approachCost">
                            <label>{{$t("realEstate.field.cadastreSection")}} <span class="red">*</span></label>
                            <div class="row">
                              <div class="col-md-12">
                                <treeselect class="form-control" v-model="realEstate.cadastreSections"
                                            placeholder="Танланг..."
                                            :options="cadastreSections"
                                            :multiple="true"
                                >
                                  <!--:load-options="onCadastreSectionSearch"-->
                                  <!--:auto-load-root-options="false"-->
                                </treeselect>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="red" v-if="$v.realEstate.sections.$error">
                          {{$t("realEstate.validation.cadastreSection")}}
                        </div>
                      </div>
                      <div class="col-md-4">
                        <button class="all-btn btn-sm add-btn pull-right mr-3" v-tooltip="$t('realEstate.field.addBuilding')" @click="addBuilding" v-if="isEditable">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                      <div class="col-12">
                        <section v-for="(building, index) in realEstate.buildings" :key="building.id">
                          <div class="row">
                            <div class="col-12" v-if="hasPermission('NEW_REAL_ESTATE_BUILDING_DELETE') && isEditable">
                              <button type="button"
                                      v-tooltip="'Бинони ўчириш'"
                                      class="all-btn delete-btn btn-sm float-right mr-3"
                                      @click="showDeleteBuildingDialog(building, index)"
                                      v-if="!building.isNotExist && !building.isNotEvaluated"
                              >
                                <i class="fa fa-trash-o"></i>
                              </button>
                            </div>
                            <div class="col-12" v-if="building.hasComparative">
                              <NewRealEstateBuildingComparativeEdit
                                  v-if="!initLoading"
                                  :asIncomeValid="realEstate.approachIncome"
                                  :buildingId="building.id"
                                  :index="index"
                                  :ref="`childBuilding-${index}`"
                                  :isRemoveFile="canRemoveFile"
                                  :isEditableFile="canSave"
                              />
                            </div>
                            <div class="col-12" v-else>
                              <NewRealEstateBuildingEdit
                                      v-if="!initLoading"
                                      :asIncomeValid="realEstate.approachIncome"
                                      :buildingId="building.id"
                                      :approachCost="realEstate.approachCost"
                                      :index="index"
                                      :ref="`childBuilding-${index}`"
                                      :isRemoveFile="canRemoveFile"
                                      :isEditableFile="canSave"
                                      @handle-building-photos="handleBuildingPhotos"
                              />
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.new-comparison v-tooltip="'Янги қиёсий ёндашув маълумотларини куриш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{ $t("realEstate.approach.comparative") }}
                        <b class="ml-4" v-if="realEstate.approachComparative">
                          <span
                              v-if="isApproachComparative">{{
                              realEstate.newComparison.calculatedTotalPrice | currency('', 2, {thousandsSeparator: ' '})
                            }} сўм</span>
                        </b>
                        <b v-else class="red">
                          <span
                              v-if="realEstate.newComparison && realEstate.newComparison.message">{{
                              realEstate.newComparison.message
                            }}</span>
                          (воз кечилди)
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="new-comparison" accordion="evl-accordion" role="tabpanel">
                    <NewRealEstateComparison v-if="!initLoading" :realEstate="realEstate" :references="cadastreBuildingFieldReferences"/>
                  </b-collapse>
                </div>
              </div>
              <div class="row" v-if="!canShowForAllSpecialUsers">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.income v-tooltip="'Даромад ёндашув маълумотларини куриш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{ $t("realEstate.approach.income") }}
                        <b class="ml-4" v-if="realEstate.approachIncome">
                          <span
                              v-if="subBuildingIncomeTotal(realEstate.comparisonNewIncome) > 0">{{
                              subBuildingIncomeTotal(realEstate.comparisonNewIncome) | currency('', 2, {thousandsSeparator: ' '})
                            }} сўм</span>
                        </b>
                        <b v-else class="red">(воз кечилди)</b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="income" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group" v-if="hasPermission('NEW_REAL_ESTATE_INCOME_RENT')">
                          <div class="form-check">
                            <label class="form-check-label income-text">
                              <input class="form-check-input" type="checkbox" v-model="realEstate.incomeRentEnabled">
                              <span class="form-check-sign"></span>
                              Ҳоким ижара ставкаси орқали ижарани ҳисоблаш
                            </label>
                          </div>
                        </div>
                        <NewRealEstateIncomeView
                            v-if="!initLoading"
                            :realEstate="realEstate"
                            :owner="realEstate.owner"
                            :approachIncome="realEstate.approachIncome"
                        ></NewRealEstateIncomeView>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.coordination v-tooltip="'Мувофиқлаштириш маълумотларини куриш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        <!--{{$t("realEstate.field.basicInformation")}}-->
                        Мувофиқлаштириш
                        <b class="ml-4" v-if="realEstate.evlTotal && realEstate.evlTotal > 0">
                          <span>{{ realEstate.evlTotal | currency('', 2, {thousandsSeparator: ' '}) }} сўм</span>
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="coordination" accordion="evl-accordion" role="tabpanel">
                    <NewRealEstateCoordinationView v-if="!initLoading"></NewRealEstateCoordinationView>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12 mt-2">
                <div class="form-group">
                  <real-estate-status-view v-if="!initLoading" :realEstate="realEstate"/>
                </div>
              </div>
              <div class="col-md-6 col-12 mt-2">
                <div class="form-group">
                  <real-estate-history-view v-if="!initLoading"/>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" @click="save" :disabled="processing"
                        v-if="canSave">{{ $t("action.save") }}
                </button>
                <button class="all-btn" @click="changeStatus('Evaluated')"
                        :disabled="processing" v-if="canEvaluate">{{ $t("realEstate.action.evaluate") }}
                </button>
                <button class="all-btn add-btn" @click="changeStatus('Confirmed')"
                        :disabled="processing" v-if="canConfirm">{{ $t("realEstate.action.confirm") }}
                </button>
                <button class="all-btn add-btn" @click="sendReportToMIBRealEstate()"
                        v-if="hasPermission('SEND_TO_MIB_REAL_ESTATE') && isOrgTypeMib && realEstate.status === 'Confirmed'"
                >
                  {{ $t("realEstate.action.sendReportToMIB") }}
                </button>
                <button class="all-btn edit-btn" @click="changeStatus('NotFullyEvaluated')"
                        :disabled="processing" v-if="canReEvaluate">
                  {{ $t("realEstate.action.reevaluate") }}
                </button>
                <button class="all-btn" v-if="canSendAgent"
                        :disabled="processing"
                        @click="changeStatus('NotReady')">
                  {{ $t('main.send') }}
                </button>
                <button class="all-btn pull-right"
                        v-if="canSignEsp"
                        @click="onSignDirectorEsp"
                >
                  {{ $t("realEstate.action.espSign") }}
                </button>
                <button class="all-btn pull-right"
                        v-if="canSignEspAppraisal"
                        @click="onSignAppraisalEsp"
                >
                  {{ $t("realEstate.action.espSign") }}
                </button>
                <button class="all-btn edit-btn"
                        v-if="canSave"
                        :disabled="processing"
                        @click="sendFixError"
                >
                  <i class="fa fa-warning"></i>
                  <span>{{$t("realEstate.plus.sendFixError.title")}}</span>
                </button>
                <button class="all-btn add-btn"
                        v-if="canSave"
                        :disabled="processing"
                        @click="getFixError"
                >
                  <i class="fa fa-upload"></i>
                  <span>{{$t("realEstate.plus.sendFixError.upload")}}</span>
                </button>
                <button class="all-btn add-btn" @click="onUpdateValues" :disabled="processing"
                        v-if="realEstate.status === 'Confirmed'">
                  <i class="fa fa-refresh"></i>
                  <span>Янгилаш маълумот</span>
                </button>
              </div>
            </div>
            <div class="row mt-3" v-if="realEstate.status === 'Confirmed'">
              <div class="col">
                <div class="alert alert-warning d-flex">
                  <i class="fa-fw fa fa-warning mr-1"></i>
                  <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан
                    (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewRealEstatePlusActModal :disable-fields="true"/>
    <NewRealEstateBindAgentModal/>
    <NewRealEstateCostModal/>
    <NewRealEstateSurveyModal/>
    <CadastreFixErrorModal :error-msg="$t('realEstate.plus.sendFixError.description')"
                           :request-id="realEstate && realEstate.requestId"
                           :evl-object-type="'Building'"
                           :sender-source="'EVALUATOR'"
                           :required-ident="false"
                           @handle-success="cancel"
    />
    <ConstructionCompletionPercentageModal @handle-completion-data="handleCompletionData"/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import {numericTypes} from '@/shared/constants/mask'
import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone'
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import initFilterModel from '@/shared/filter';
import {formatDate, parseDate, updateDifferences2} from '@/shared/utils';
import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
import RealEstateLocationMap from '@/views/e-appraisal/RealEstateLocationMap'
import RealEstateStatusView from '../../RealEstateStatusView.vue'
import RealEstateHistoryView from '../../RealEstateHistoryView.vue'
import NewRealEstateCostModal from '../NewRealEstateCostModal.vue'
import NewRealEstateIncomeView from '@/views/real-estate/new/NewRealEstateIncomeView'
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import NewRealEstateBuildingEdit from "../NewRealEstateBuildingEdit";
import NewRealEstateCoordinationView from '../NewRealEstateCoordinationView';
import StepProgress from '../NewRealEstateStepProgress'
import {TheMask} from 'vue-the-mask';
import NewRealEstateComparison from '@/views/real-estate/new/NewRealEstateComparison'
import CustomDatePicker from "@/views/common/CustomDatePicker";
import AdvancedFilter from '@/shared/filters/advancedFilter';
import NewRealEstatePlusActModal from '@/views/real-estate/new/plus/NewRealEstatePlusActModal'
import NewRealEstateBindAgentModal from "../NewRealEstateBindAgentModal";
import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
import NewRealEstateBuildingComparativeEdit from "../NewRealEstateBuildingComparativeEdit";
import fireBaseDb from '@/shared/firebase/firebasedb'
import NewRealEstateSurveyModal from '@/views/real-estate/new/NewRealEstateSurveyModal';
import InnerImageZoom from 'vue-inner-image-zoom';
import NewLandPlusCalculationView from '@/views/real-estate/new/plus/NewLandPlusCalculationView'
import CadastreInput from "@/components/CadastreInput.vue";
import {cadastreNumber} from "@/shared/validator-helpers";
import CadastreFixErrorModal from "@/components/cadastre/CadastreFixErrorModal.vue";
import {mapState} from "vuex";
import ConstructionCompletionPercentageModal from "@/components/real-estate/ConstructionCompletionPercentageModal.vue";
import {parseToData} from '@/shared/real-estate-utils'

export default {
  name: "NewRealEstatePlusEdit",
  components: {
    CadastreFixErrorModal,
    CadastreInput,
    NewRealEstateBindAgentModal,
    CustomDatePicker,
    NewRealEstateBuildingEdit,
    Datepicker,
    Treeselect,
    RealEstateDropZone,
    PreviewDropZone,
    RealEstateLocationMap,
    RealEstateStatusView,
    RealEstateHistoryView,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    // NewRealEstateIncomeCalculationView,
    NewRealEstateCoordinationView,
    StepProgress,
    TheMask,
    NewRealEstateComparison,
    NewRealEstateIncomeView,
    NewRealEstatePlusActModal,
    NewRealEstateCostModal,
    NewRealEstateBuildingComparativeEdit,
    NewRealEstateSurveyModal,
    InnerImageZoom,
    NewLandPlusCalculationView,
    ConstructionCompletionPercentageModal
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      isDocQrLoading: false,
      isDocLoading: false,
      isPdfLoading: false,
      isPdfQrLoading: false,
      isCDocLoading: false,
      isCPdfLoading: false,
      isCDocQrLoading: false,
      isCPdfQrLoading: false,
      loadCadastreDoc: false,
      isOtherPdfLoading: false,
      initLoading: true,
      imageLoading: false,
      numericTypes: numericTypes,
      ownerFilter: initFilterModel(),
      customerFilter: initFilterModel(),
      cadastreSectionFilter: initFilterModel(),
      filter: initFilterModel(),
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      filterMfy: initFilterModel(),
      filterMicroRegion: new AdvancedFilter(),
      filterBuildingType: new AdvancedFilter(),
      show: false,
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      realEstate: {
        id: null,
        owner: null,
        customer: null,
        hasCustomer: false,
        approachCost: false,
        approachIncome: true,
        approachComparative: true,
        category: 'Notorious',
        evlGoalType: 'Predge',
        name: '',
        cadastreDocNumber: '',
        cadastreSections: [],

        address: '',
        province: {},
        region: {},

        //MIB
        mibDebtorName: '',
        mibLetterNumber: '',
        mibLetterDate: null,
        mibRegion: null,

        evlGroundArea: 0,
        evlBuildingWidthArea: 0,
        evlUsefulField: 0,
        evlTotalArea: 0,
        evlContractAmount: 0,
        prepayment: 0,

        employee: {},

        evlValueType: 'Market',
        evlPropertyType: '',

        landComparisonEnabled: false,
        landCapitalizationEnabled: false,
        landLeaseEnabled: false,
        landOwnerEnabled: false,
        buildings: [],
        payments: [],

        passport: [],// паспорт файл
        actOfSale: [],// далолатнома
        decision: [],// карор нусхаси
        playlist: [],// ижро варакаси
        balance: [],// баланс
        cadastre: [],// кадастр хужжати
        applicationForm: [],// ариза
        documents: [],// мурожат хати
        buildingPhotos: [],// бино расмлари
        privatizationLetter: [],// Кумитанинг бахолаш тугрисида хати
        privatizationCommissionOrder: [],// Хусусийлаштириш комиссиясининг буйрук ва протоллари
        ownershipCertificate: [],// Эгалик хукукинитасдикловчи гувохнома
        checkPaymentFiles: [],// to'lov haqidagi hujjatlar
        status: 'Pending',

        displayReport: false,
        evaluatorIdea: '',

        landCapitalization: {
          financingRate: 0,
          taxPerHectare: 0,
          calculatedTotalPrice: 0
        },
        reasonDesc: '',
        approachRegression: false,
        sectionId: null,
        contractAmountByAgreement: null,
        contractAmountByAgreementDescription: null,
        lightConstructiveElement: false,
        version: 'V3',
        buildingType: '',
        subBuildingType: '',
        microRegionId: null,
        repairCondition: '',
        wall: '',
        builtYear: 2000,
        floor: 1,
        storey: 1,
        newComparison: {},
        evlTotal: null,
        cadastreData: null,
        wizardSection: 0,
        financingRate: 0,
        buildingCondition: false,
        cadastreBalance: 0,
        evaluationRespectiveType: "OTHER",
        specialComfort: null,
        constructionCompletion: 100,
        architecturalStyle: null,
        tenderContractDate: null,
        tenderContractNumber: null,
        separateBuilding: false,
        photos: [],
        fixByIndex: false,
        transportPlace: null,
        landLeaseData: {},
        powerOfAttorneyNumber: null,
        powerOfAttorneyDate: null,
        incomeRentEnabled: false,
        data: {
          values: {},
          cadastreSections: []
        },
        evaluatorTerms: '',
        mfy: null,
        type: 'BASIC',
        isMicroRegionSelected: false,
        assetItemId: null,
        hasTotalArea: false,
        borrower: null
      },
      owners: [],
      customers: [],
      provinces: [],
      regions: [],
      cadastreSections: [],
      employees: [],
      goalTypes: [],//EVL_GOAL_TYPES,
      goalTypesCommon: ['Predge', 'Sale', 'DeterminingValue', 'FormationStatutoryFund', 'Losses', 'DeterminationMarketValue', 'Investment', 'AcceptToBalance', 'Inheritance', 'ForTax','DeterminationValue'],
      propertyTypes: [], //EVL_PROPERTY_TYPES,
      mibLetterDate: null,
      financingRate: 0,
      taxPerHectare: 0,
      buildingSections: [],
      buildingTypes: [],
      subBuildingTypes: [],
      rowIndex: 0,
      microRegions: [],
      buildingType: null,
      subBuildingType: null,
      repairConditions: [],
      repairCondition: null,
      walls: [],
      wall: null,
      maxMadeYear: new Date().getFullYear(),
      minMadeYear: new Date(0).getFullYear(),
      purposeRentingAreas: [],
      newComparisonMsg: '',
      cadastreDocLength: 28,
      realEstateVisible: false,
      evaluationRespectiveTypes: [],
      specialComfort: null,
      specialComforts: [],
      architecturalStyle: null,
      architecturalStyles: [],
      coordination: null,
      cadastreBuildingFields: [],
      cadastreBuildingFieldsClone: [],
      cadastreBuildingFieldReferences: {},
      communications: [],
      transportPlace: null,
      powerOfAttorneyDate: null,
      status: null,
      loadEdit: false,
      ref: {
        ...COMPARISON_REFERENCES
      },
      oldEvaluationWorks: null,
      loadFireBase: false,
      fireBaseRequest: {
        username: null,
        created_at: new Date(),
        web_status: 'DEACTIVATED',
        evlType: 'REAL_ESTATE',
        android_status: 'DEACTIVATED',
        source: "INSIDE",
        key: null
      },
      formFields: {
        fields: ["basement_building_type", "housing_type", "house_cover", "house_top", "floor_type", "land_owner_right", "non_market_type", "electrical_devices", "height", "height_inner", "elevator", "window", "door", "land_fund_category"]
      },
      selectedRealEstateDocsTab: "images",
      realEstateDocs: [],
      realEstateAllPhotos: [],
      mfyList: [],
      minValueUsefulArea: 0.01,
      oldCadastreDocNumber: null,
      minEvlTotalArea: 0,
      disabledFields: ["basement_building_type", "housing_type", "electrical_devices"],
      disabledFieldsForDirector: ["basement_building_type", "housing_type"],
      fieldsAlignment: {
        window_and_doors: 1,
        electrical_devices: 1,
        height: 2,
        height_inner: 2
      },
      // enabledFieldsForSpecialUser: ["window_and_doors", "housing_type"],
      enabledFieldsForSpecialUser: ["height", "height_inner", "window_and_doors", "housing_type", "elevator"],
      hiddenFieldsForSpecialUser: ["basement_building_type", "electrical_devices", "height", "height_inner", "elevator", "window", "door", "house_cover", "house_top", "floor_type"],
      hiddenFieldsForSpecialUser2: ["housing_type", "electrical_devices", "window", "door", "house_cover", "house_top", "floor_type"],
      canChangeSubBuildingType: false,
      hiddenMultiStoreyFields: ["electrical_devices"],
      fieldSet: null
    }
  },
  validations() {
    return {
      realEstate: {
        /*LEFT PANEL*/
        owner: {
          required: required
        },
        customer: {
          required: requiredUnless(() => {
            return !(this.realEstate.hasCustomer);
          })
        },
        powerOfAttorneyNumber: {
          required: requiredUnless(() => {
            return !(this.realEstate.hasCustomer);
          })
        },
        approach: {
          required: requiredUnless(() => {
            return !(!(this.realEstate.approachCost || this.realEstate.approachComparative || this.realEstate.approachIncome || this.realEstate.approachRegression));
          })
        },
        evlGoalType: {
          required: required
        },
        cadastreDocNumber: {
          required: required,
          cadastreNumber: cadastreNumber
        },
        sections: {
          required: requiredUnless(() => {
            return !(this.isSections);
          })
        },
        // cadastreSections: {
        //     required: required,
        //     minLength: minLength(1)
        // },
        province: {
          id: {
            required: required
          }
        },
        region: {
          id: {
            required: required
          }
        },
        address: {
          required: required
        },
        /*RIGHT PANEL*/
        // evlGroundArea: {
        //     required: required,
        //     minValue: minValue(0.01)
        // },
        evlBuildingWidthArea: {
          required: requiredUnless(() => {
            return !!this.isEvlTotalAreaEntered
          })
        },
        evlUsefulField: {
          required: required,
          minValue: minValue(this.minValueUsefulArea)
        },
        evlValueType: {
          required: required
        },
        evlPropertyType: {
          required: required
        },
        employee: {
          id: {
            required: requiredUnless(() => {
              return this.isSentToComplement || this.isAssignEmployee || this.hasAssetItem
            })
          }
        },
        // MIB
        mibDebtorName: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        mibLetterNumber: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        cadastre: {
          required: requiredUnless(() => {
            return !(this.isOwnerTypeLegal || (this.isOwnerTypePhysical && this.isGoalTypeCommon));
          }),
          minLength: minLength(1)
        },
        photos: {
          required: requiredUnless(() => {
            return !this.isSourceInside;
          }),
          minLength: minLength(1)
        },
        // evlContractAmount: {
        //   required: requiredUnless(() => {
        //     return (this.isOwnerTypeLegal && this.isOrgTypeMib) || this.isSentToComplement || this.hasAssetItem
        //   }),
        //   minValue: minValue((!(this.isOwnerTypeLegal && this.isOrgTypeMib) && !this.isSentToComplement && !this.hasAssetItem) ? 0.01 : 0)
        // },
        storey: {
          required: required,
          minValue: minValue(1)
        },
        floor: {
          required: requiredUnless(() => {
            return !!(this.isSeparateBuilding)
          })
        },
        builtYear: {
          required: required,
          minValue: minValue(1)
        },
        cadastreBalance: {
          required: requiredUnless(() => {
            return !(this.isApproachIncome);
          })
        },
        evaluationRespectiveType: {
          required: required
        },
        microRegionId: {
          required: requiredUnless(() => {
            return !(this.isMicroRegionSelected)
          })
        },
        constructionCompletion: {
          required: required,
          minValue: minValue(0.01)
        },
        tenderContractDate: {
          required: requiredUnless(() => {
            return !this.isTenders;
          })
        },
        tenderContractNumber: {
          required: requiredUnless(() => {
            return !this.isTenders;
          })
        },
        mfy: {
            required: required
        },
        evlTotalArea: {
          required: requiredUnless(() => {
            return !this.realEstate.hasTotalArea
          }),
          minValue: minValue(this.minEvlTotalArea)
        }
      },
      mibLetterDate: {
        required: requiredUnless(() => {
          return !(this.isOrgTypeMib);
        })
      },
      buildingType: {
          code: {
              required: required
          }
      },
      subBuildingType: {
          code: {
              required: requiredUnless(() => {
                  return !!(this.isMultiStorey || this.isResidential || !this.subBuildingTypes.length)
              })
          }
      },
      repairCondition: {
        code: {
          required: required
        }
      },
      wall: {
        code: {
          required: required
        }
      },
      specialComfort: {
        code: {
          required: required
        }
      },
      architecturalStyle: {
        code: {
          required: required
        }
      },
      powerOfAttorneyDate: {
        required: requiredUnless(() => {
          return !(this.realEstate.hasCustomer);
        })
      },
      cadastreBuildingFields: {
        $each: {
          value: {
            required: requiredUnless(vm => {
              return !this.hasField(vm.code);
            })
          }
        }
      }
    };
  },
  computed: {
    ...mapState(['profile']),
    isOwnerTypePhysical() {
      return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Physical' && this.realEstate.source !== 'API_EXARID');
    },
    isOwnerTypeLegal() {
      return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Legal' || this.realEstate.source === 'API_EXARID');
    },
    isOrgTypeMib() {
      return !!(this.realEstate.owner && this.realEstate.owner.organizationType && this.realEstate.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');
    },
    isGoalTypeCommon() {
      return this.isGoalType(this.goalTypesCommon);
    },
    isPrivatizationSimple() {
      return this.isGoalType(['Privatization']);
    },
    isPrivatizationZero() {
      return this.isGoalType(['PrivatizationZero']);
    },
    canSave() {
      return (this.realEstate.status === 'Pending' || this.realEstate.status === 'AssignedToEvaluator'
          || this.realEstate.status === 'NotFullyEvaluated' || this.realEstate.status === 'SentToComplement')
          || this.realEstate.status === 'ErrorInPrice';
    },
    canEvaluate() {
      let hasBuildingCalculated = false;
      if (this.realEstate.status === 'NotFullyEvaluated' && this.hasPermission('REAL_ESTATE_EVALUATE')) {
        this.realEstate.buildings.forEach((building) => {
          if (building.calculated && building.calculated.price && building.calculated.price.expense && building.calculated.price.expense > 0) {
            hasBuildingCalculated = true;
          }
        });
        if ((this.realEstate.newComparison && this.realEstate.newComparison.calculatedTotalPrice && this.realEstate.newComparison.calculatedTotalPrice > 0) ||
            (this.realEstate.newIncome && this.realEstate.newIncome.calculated && this.realEstate.newIncome.calculated.total > 0)) {
          hasBuildingCalculated = true;
        }
      }
      return hasBuildingCalculated;
    },
    canConfirm() {
      return this.realEstate.status === 'Evaluated' && this.hasPermission('REAL_ESTATE_CONFIRM') && (this.realEstate.appraiserReportEsp || !this.realEstate.hasEsp);
    },
    canReEvaluate() {
      return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.hasPermission('REAL_ESTATE_REEVALUATE');
    },
    checkPaymentLbl() {
      return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
    },
    calculated() {

      let landTaxAmount = 0;
      let financingRate = 0;
      let taxPerHectare = 0;
      let calculatedTotalLandPrice = 0;

      const areaInHectare = this.realEstate.evlGroundArea * 0.0001;

      if (this.taxPerHectare > 0) {
        taxPerHectare = this.taxPerHectare;
        landTaxAmount = taxPerHectare * areaInHectare;
      }
      if (this.financingRate > 0) {
        financingRate = this.financingRate;
        calculatedTotalLandPrice = landTaxAmount / financingRate * 100;
      }
      return {
        financingRate: financingRate,
        taxPerHectare: taxPerHectare,
        areaInHectare: areaInHectare,
        landTaxAmount: landTaxAmount,
        calculatedTotalLandPrice: calculatedTotalLandPrice
      }
    },
    showReportButton() {
      return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.realEstate.id && this.realEstate.id > 0;
    },
    isSections() {
      return !(this.realEstate.cadastreSections && this.realEstate.cadastreSections.length > 0) && this.realEstate.approachCost && this.realEstate.status != 'SentToComplement'
    },
    isEditable() {
      return this.realEstate.status !== 'Confirmed' && this.realEstate.status !== 'Evaluated';
    },
    isApproachComparative() {
      return this.realEstate.newComparison && this.realEstate.newComparison.calculatedTotalPrice
    },
    isApproachIncome() {
      return this.realEstate.approachIncome;
    },
    isSeparateBuilding() {
      return (this.buildingType && this.buildingType.code !== 'RESIDENTIAL_MULTI_STOREY') && (this.realEstate.separateBuilding)
    },
    isNoChangeIncome() {
      return this.repairCondition && this.repairCondition.code === 'wreckage' && this.realEstate.evlGoalType !== 'Losses'
    },
    totalBuildingIncome() {
      return this.realEstate.buildings
          .map(building => this.subBuildingIncomeTotal(building.newIncome))
          .reduce((a, b) => a + b, 0)
    },
    totalIncomeLandCost() {
      return this.realEstate.buildings.map(building => {
        if (building.newIncome && building.newIncome.calculated) {
          return building.newIncome.calculated.propertyTaxAmount + building.newIncome.calculated.landTaxAmount;
        }
      })[0];
    },
    isPaid() {
      return this.realEstate.paidAmount > 0;
    },
    isOnlineAndApi() {
      return this.realEstate.source === 'ONLINE' || this.realEstate.source === 'API_MIB'
          || this.realEstate.source === 'API' || this.realEstate.source === 'API_BANK' || this.realEstate.source === 'ONLINE_PLUS'
    },
    isTenders() {
      return this.realEstate.evaluationRespectiveType === 'TENDERS';
    },
    isCollapseVisibleDocs() {
      if (this.isOwnerTypePhysical) {
        return (this.$v.realEstate.passport.$error || this.$v.realEstate.cadastre.$error)
      } else {
        return (this.$v.realEstate.documents.$error || this.$v.realEstate.actOfSale.$error
            || this.$v.realEstate.decision.$error || this.$v.realEstate.playlist.$error || this.$v.realEstate.cadastre.$error)
      }
    },
    isMultiStorey() {
      return this.realEstate.buildingType && this.realEstate.buildingType === 'RESIDENTIAL_MULTI_STOREY'
    },
    isResidential() {
      return this.realEstate.buildingType && this.realEstate.buildingType === 'RESIDENTIAL_INDIVIDUAL'
    },
    canSendAgent() {
      return (this.realEstate.status === 'SentToComplement' && this.hasPermission('REAL_ESTATE_EDIT'))
    },
    isSentToComplement() {
      return (this.realEstate.status === 'SentToComplement') || this.isSourceExpert2
    },
    isSourceExpert2() {
      return this.realEstate && this.realEstate.source === 'EXPERT2'
    },
    isApproachCost() {
      return this.hasPermission('REAL_ESTATE_APPROACH_COST');
    },
    isAssignEmployee() {
      return !this.hasPermission('REAL_ESTATE_ASSIGN')
    },
    canRemoveFile() {
      return this.status && this.status !== 'Evaluated' && this.status !== 'Confirmed' && this.status !== 'Rejected' && this.hasPermission('REAL_ESTATE_IMAGE_DELETE');
    },
    /*isUsefulAreaValidation() {

      if (this.hasPermission('NEW_REAL_ESTATE_USEFUL_AREA_ACCEPT')) {
        return true;
      }

      let area = this.realEstate.evlGroundArea ? this.realEstate.evlGroundArea : 0;
      let areaBuilding = this.realEstate.evlBuildingWidthArea ? this.realEstate.evlBuildingWidthArea : 0;
      let basementBuildingType = '';
      let usefulArea = this.realEstate.evlUsefulField ? this.realEstate.evlUsefulField : 0;
      let storey = this.realEstate.storey;

      if (this.realEstate.data && this.realEstate.data.values) {
        const basement = this.realEstate.data.values['basement_building_type'];
        if (basement) {
          basementBuildingType = basement.code;
        }
      }

      if (this.isMultiStorey) {
        return true;
      } else if (basementBuildingType === 'WITH_BASEMENT') {
        return (storey + 1) * area >= usefulArea || (storey + 1) * areaBuilding >= usefulArea;
      } else
        return storey * area >= usefulArea || storey * areaBuilding >= usefulArea;
    },*/
    canSignEsp() {
      return this.hasPermission('REAL_ESTATE_CONFIRM') && this.realEstate.status === 'Confirmed' && this.realEstate.appraiserReportEsp && this.realEstate.hasEsp && !this.realEstate.directorReportEsp
    },
    canSignEspAppraisal() {
      return this.hasPermission('REAL_ESTATE_EVALUATE') && this.realEstate.status === 'Evaluated' && this.realEstate.hasEsp && !this.realEstate.appraiserReportEsp
    },
    hasActData() {
      return this.realEstate.data && this.realEstate.data.values
    },
    canFireBaseSendMassage() {
      return !this.realEstate.id && !(this.realEstate.cadastreDocNumber ||
          this.realEstate.evlGroundArea || this.realEstate.evlBuildingWidthArea ||
          this.realEstate.evlUsefulField || this.realEstate.name || this.realEstate.address)
    },
    isSourceInside() {
      return this.realEstate && this.realEstate.source === 'INSIDE'
    },
    isMicroRegionSelected() {
      return this.realEstate && this.realEstate.isMicroRegionSelected
    },
    isEvaluationForItem() {
      return this.realEstate.buildings && this.realEstate.buildings.length > 0
          && this.realEstate.status === 'NotFullyEvaluated' && this.hasPermission('REAL_ESTATE_ITEM_EVALUATION')

          // && !this.realEstate.evlTotal && this.hasPermission('REAL_ESTATE_ITEM_EVALUATION')
    },
    hasAssetItem() {
      return this.realEstate.assetItemId
    },
    hasTotalArea() {
      return this.realEstate.hasTotalArea
    },
    isEvlTotalAreaEntered() {
      return !this.realEstate.evlBuildingWidthArea && this.realEstate.evlTotalArea && this.realEstate.evlTotalArea > 0
    },
    canShowForAllSpecialUsers() {
      return this.profile && (this.profile.username === 'kenjabek' || this.profile.username === 'asadbek_baholovchi' || this.profile.username === 'urazboy')
    },
    isUserSpecial() {
      return this.profile && (this.profile.username === 'kenjabek' || this.profile.username === 'asadbek_baholovchi')
    },
    isUserSpecial2() {
      return this.profile && this.profile.username === 'urazboy'
    },
    canShowFieldForSpecialUser() {
      return this.isUserSpecial
          ? this.isMultiStorey
          : this.isUserSpecial2
              ? !this.isMultiStorey
              : true
    },
    isUserAppraiser() {
      return this.profile && this.profile.authorities && this.profile.authorities.includes("ROLE_APPRAISER")
    },
    isUserDirector() {
      return this.profile && this.profile.username === 'shohrux';
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;
      let category = '';
      if (this.$route && this.$route.meta && this.$route.meta.category && this.$route.meta.category.length > 0) {
        category = this.$route.meta.category;
      }
      const promises = [
        this.$http.get('admin/new-real-estate/init/' + ((category && category.length > 0) ? category : 'na') + '/' + ((id && id > 0) ? id : '0'))
      ];
      if (id && id > 0) {
        vm.loadEdit = true;
        promises.push(this.$http.get('admin/new-real-estate/' + id));
      } else {
        vm.realEstate.category = category;
      }
      Promise.all(promises).then(function (values) {
        const initData = values[0].data;
        vm.employees = initData.employees;
        vm.cadastreSections = initData.cadastreSections.map((item) => {
          item.label = item.name;
          return item;
        });
        vm.buildingSections = initData.buildingSections;
        vm.cadastreBuildingFieldReferences = initData.references;
        vm.goalTypes = initData.evlGoalTypes
        vm.propertyTypes = initData.propertyTypes;

        if (vm.cadastreBuildingFields.length > 0) {
          vm.cadastreBuildingFields = []
        }

        vm.formFields.fields.forEach((field) => {
          const buildingField = initData.fields.filter((f) => f.code === field);
          if(vm.fieldsAlignment.hasOwnProperty(field) && buildingField[0]) {
            buildingField[0].alignment = vm.fieldsAlignment[field];
          }
          vm.cadastreBuildingFields.push(buildingField[0]);
          vm.cadastreBuildingFieldsClone = JSON.parse(JSON.stringify(vm.cadastreBuildingFields))
        });

        if (values.length >= 2) {
          const editData = values[1].data;

          if (editData.data && editData.data.values) {
            vm.cadastreBuildingFields.forEach((field) => {
              if (field && field.code && editData.data.values.hasOwnProperty(field.code)) {
                const fieldValue = editData.data.values[field.code];
                if (fieldValue) {
                  if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                    if (fieldValue.id && fieldValue.id > 0) {
                      field.value = fieldValue.id;
                      field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                    }
                  } else if (field.type === 'MULTISELECT') {
                    if (fieldValue) {
                      field.selected = [];
                      if (fieldValue.length > 0) {
                        fieldValue.forEach((ref) => {
                          field.selected.push(ref.id);
                        });
                      } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                        field.selected.push(fieldValue.id);
                      }
                      field.value = field.selected;
                    }
                  } else {
                    field.value = fieldValue;
                  }
                }
              }
            });
          }

          if (!editData.data) {
            editData.data = {};
          }
          if (!editData.data.values) {
            editData.data.values = {};
          }

          if (!editData.evlGoalType) {
            editData.evlGoalType = '';
          }
          if (!editData.province) {
            editData.province = {};
          }
          if (!editData.region) {
            editData.region = {};
          }
          if (!editData.employee) {
            editData.employee = {};
          }
          if (!editData.wizardSection) {
            editData.wizardSection = 0
          }
          vm.mibLetterDate = parseDate(editData.mibLetterDate);

          if (editData.powerOfAttorneyDate) {
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate)
          }
          vm.realEstate = editData;
          if (editData.landCapitalization && editData.landCapitalization.financingRate > 0 && editData.landCapitalization.taxPerHectare > 0) {
            vm.initLandCapitalizationData(editData.landCapitalization)
          }
          if (editData.financingRate) {
            vm.financingRate = editData.financingRate;
          }

          if (editData.buildingType) {
            vm.initBuildingType();
          }
          if (editData.repairCondition) {
            vm.initRepair();
          }
          if (editData.wall) {
            vm.initConstructiveElement();
          }

          if (editData.newIncome) {
            vm.newIncome = editData.newIncome
          }

          if (editData.specialComfort) {
            vm.initSpecialComfort()
          }

          if (editData.architecturalStyle) {
            vm.initArchitecturalStyle()
          }
          vm.status = editData.status;
          vm.loadEdit = false;
          // vm.onGoalTypeChange();

          if (editData.status === 'AssignedToEvaluator' || (editData.status === 'Pending' && editData.source === 'INSIDE')) {
            vm.searchRealEstateComparativeEvaluated({status: 'Confirmed', category: editData.category, cadastreDocNumber: editData.cadastreDocNumber})
          }

          vm.searchOldEvalautionWork()
          vm.onChangeConstructionCompletion()

          if ((vm.realEstate.evlGoalType || vm.realEstate.source === 'API_EXARID') && !vm.loadEdit) {
            if (vm.isOwnerTypePhysical && vm.isGoalTypeCommon) {
              vm.realEstateDocs = [
                ...vm.realEstate.passport,
                ...vm.realEstate.applicationForm
              ]
            }
            if (vm.isOwnerTypeLegal && (vm.realEstate.source === 'API_EXARID' || vm.isGoalTypeCommon || vm.isPrivatizationZero)) {
              vm.realEstateDocs = [...vm.realEstateDocs, ...vm.realEstate.documents]
            }
            if (vm.isOwnerTypeLegal || vm.isOwnerTypePhysical) {
              vm.realEstateDocs = [...vm.realEstateDocs, ...vm.realEstate.cadastre]
            }
            if (vm.isOwnerTypeLegal && vm.isPrivatizationSimple) {
              vm.realEstateDocs = [
                ...vm.realEstateDocs,
                ...vm.realEstate.privatizationLetter,
                ...vm.realEstate.privatizationCommissionOrder,
                ...vm.realEstate.ownershipCertificate
              ]
            }
            if(vm.isOwnerTypeLegal) {
              vm.realEstateDocs = [
                ...vm.realEstateDocs,
                ...vm.realEstate.actOfSale
              ]
            }
            if(vm.isOwnerTypeLegal && vm.isOrgTypeMib) {
              vm.realEstateDocs = [
                ...vm.realEstateDocs,
                ...vm.realEstate.decision,
                ...vm.realEstate.playlist,
                ...vm.realEstate.balance
              ]
            }

            if(vm.realEstate.constructionCompletionDoc) {
              vm.realEstateDocs = [
                ...vm.realEstateDocs,
                ...vm.realEstate.constructionCompletionDoc
              ]
            }
          }
          vm.realEstate.photos.forEach((file) => {
            vm.realEstateAllPhotos.push(file);
          });

          if(!vm.hasPermission('REAL_ESTATE_VIEW_FULL_DATA') && vm.realEstate.buildings && vm.realEstate.buildings.length > 0) {
            vm.buildingPhotosByRealEstateId(vm.realEstate.id)
          }

          if (editData.microRegionId) {
            vm.onMfyChange()
          }
        }
      });

      vm.initLoading = false
    },
    buildingPhotosByRealEstateId(realEstateId) {
      if (realEstateId) {
        this.imageLoading = true;
        this.$http.get('/new-real-estate/building-photos/' + realEstateId)
            .then(response => {
              if (response && response.data && response.status === 200) {
                this.realEstateAllPhotos.push(...response.data);
              }
              this.imageLoading = false;
            })
            .catch(err => {
              console.log(err);
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.common.error'),
                type: 'warning'
              });
              this.imageLoading = false;
            })
      }
    },
    handleBuildingPhotos(buildingPhotos) {
        this.realEstateAllPhotos = [...this.realEstateAllPhotos, ...buildingPhotos]
    },
    addBuilding() {
      let item = {
        //rowIndex: this.realEstate.buildings.length
      };
      this.realEstate.buildings.push(item);
      //this.rowIndex++;
      // this.$router.push('/real-estate/building/new/' + this.realEstate.id);
    },
    cancel() {
      const routeQuery = this.$route.query.route
      if(this.hasAssetItem && routeQuery === 'AssetItem') {
        this.$router.push('/asset-plus/item/edit/' + this.realEstate.assetItemId);
      } else {
        // this.$router.push('/new-real-estate-plus/' + this.realEstate.category.toLowerCase());
        this.$router.go(-1)
      }
    },
    multiSelectOptions(options) {
        const items = [];
        if (options && options.length > 0) {
            options.forEach((option) => {
                items.push({
                    id: option.id,
                    label: option.name
                });
            });
        }
        return items;
    },
    searchCadastre() {
      if (this.realEstate.cadastreDocNumber && this.realEstate.wizardSection <= 1) {
        this.$http.get('admin/new-real-estate/' + this.realEstate.id)
            .then(res => {
              const editData = res.data
              if (editData && editData.cadastreDocNumber
                  && !(editData.cadastreDocNumber === this.realEstate.cadastreDocNumber) && !(this.oldCadastreDocNumber === this.realEstate.cadastreDocNumber)) {
                this.oldCadastreDocNumber =  JSON.parse(JSON.stringify(this.realEstate.cadastreDocNumber))
                this.getNewCadastre()
              }
            },() => {

            })
      }
    },
    getNewCadastre() {
      this.loadCadastreDoc = true;

      let ignoreKeys = ['hasCustomer', 'cadastre', 'photos', 'documents']

      this.$http.post('/v3/real-estate/search', {cadastreNumber: this.realEstate.cadastreDocNumber, requestId: this.realEstate.requestId})
          .then(res => {
            if (res.status === 200 && res.data) {
              // console.log("res.data = ", res.data)
              // console.log("this.realEstate before = ", JSON.parse(JSON.stringify(this.realEstate)))
              Object.keys(res.data).forEach(dataKey => {
                if(!ignoreKeys.includes(dataKey)) {
                  this.realEstate[dataKey] = res.data[dataKey]
                }
              })
              // console.log("this.realEstate after = ", JSON.parse(JSON.stringify(this.realEstate)))
              // this.$forceUpdate();
              this.getProvince(res.data)
            }

            this.loadCadastreDoc = false
          }).catch(({response}) => {
        console.log('error')
        console.log(response)

        this.loadCadastreDoc = false

        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });
      });
    },
    save() {
      this.saveAndGo('close');
    },
    saveAndGo(action) {
      let isValid = true;
      this.realEstateVisible = false;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.realEstateVisible = true;
        isValid = false
        console.log('v$=', this.$v)
      }

      if ((this.realEstate.wizardSection === 1 || this.realEstate.wizardSection === 2) && (action !== 'new_land')) {
        if (this.realEstate.approachCost) {
          let properties = Object.keys(this.$refs).reverse();
          properties.forEach(el => {
            if (el.includes('childBuilding-')) {
              const bv = this.$refs[el][0].$v;
              bv.$touch();
              if (bv.$invalid) {
                isValid = false;
                this.$refs[el][0].isAddValueCollapse = true;
              }
              if (isValid) {
                this.$refs[el][0].save();
              }
            }
          });
        }
        if (isValid) {
          this.realEstate.wizardSection = 2;
        }
      } else if (isValid) {
        this.realEstate.wizardSection = 1;
      }

      if (!(isValid || action === 'new_land')) {
        return;
      }

      if (this.realEstate.prepayment && !(this.realEstate.prepayment >= 0 && this.realEstate.prepayment <= 100)) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
          type: 'warning'
        });
        return;
      }

      // this.processing = true;
      if (this.mibLetterDate) {
        this.realEstate.mibLetterDate = formatDate(this.mibLetterDate);
      }

      if (this.powerOfAttorneyDate) {
        this.realEstate.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate)
      }

      if (this.realEstate.landCapitalizationEnabled) {
        this.realEstate.landCapitalization = {
          financingRate: this.calculated.financingRate,
          taxPerHectare: this.calculated.taxPerHectare,
          calculatedTotalPrice: this.calculated.calculatedTotalLandPrice
        };
      }

      if (this.repairCondition) {
        this.realEstate.repairCondition = this.repairCondition.code;
      }

      if (this.wall) {
        this.realEstate.wall = this.wall.code;
      }
      this.realEstate.buildingType = this.buildingType.code;
      this.realEstate.financingRate = this.financingRate;

      if (!this.realEstate.floor && this.isSeparateBuilding) {
        this.realEstate.floor = 1;
      }

      if (this.specialComfort) {
        this.realEstate.specialComfort = this.specialComfort.code
      }

      if (this.architecturalStyle) {
        this.realEstate.architecturalStyle = this.architecturalStyle.code
      }

      if (this.subBuildingType && this.subBuildingType.code) {
        this.realEstate.subBuildingType = this.subBuildingType.code;
      }

      if (!this.realEstate.name.length) {
        this.realEstate.name = this.buildingType ?  this.buildingType.name : "";
      }

      this.realEstate.type = 'BASIC'

      this.$http.post('admin/new-real-estate', this.realEstate)
          .then(res => {
            this.processing = false;
            if (res.data.status !== "SUCCESS") {
              this.$swal({
                title: this.$t('messages.common.warning'),
                html: res.data.message,
                type: 'warning'
              });
              return;
            }

            if (this.realEstate.id && this.realEstate.approachComparative && this.realEstate.status !== 'Pending' && this.hasPermission('REAL_ESTATE_COMPARATIVE_ERROR_EDIT')) {
              this.findingComparativeErrors(this.realEstate.id);
            }

            if ('land' === action) {
              this.$router.push('/new-real-estate/land/' + res.data.data.id);
            } else if ('coordination' === action) {
              this.$router.push('/new-real-estate/coordination/' + res.data.data.id + '/' + false);
            } else if ('new_land' === action) {
              this.$router.push(`/new-real-estate/new-land/${this.realEstate.id}`)
            } else {
              if (!this.hasActData) {
                this.viewRealEstateAct(res.data.data.id)
              } else {
                this.getAreaReference(res.data.data.id);
              }
              // this.realEstate.id = res.data.data.id;
              // this.$router.go(this.$router.push(`/new-real-estate/edit/${res.data.data.id}`));
              /* if (this.realEstate.category === 'Residential'){
                                this.$router.push('/new-real-estate/residential');
                            } else {
                                this.$router.push('/new-real-estate/notorious');
                            } */
            }

          }).catch(({response}) => {
            console.log('error', response)
            this.$swal({
              type: 'error',
              title: '',
              text: response.data.message ? response.data.message : response.data
            });
            this.processing = false;
         })
    },
    getAreaReference(id) {
      this.$http.get(`real-estate/building-area-difference/${id}`)
          .then(res => {
            const isAreaDifference = res.data.data.isAreaDifference;
            if (isAreaDifference) {
              this.$eventBus.$emit('showRealEstateCostModal', this.realEstate);
            } else {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.success'),
                type: 'success'
              });
             /* if (this.realEstate.category === 'Residential') {
                this.$router.push('/new-real-estate-plus/residential');
              } else {
                this.$router.push('/new-real-estate-plus/notorious');
              } */
              this.cancel()
            }
          }, (e) => {
            console.log(e)
          });
    },
    saveContractAmountByAgreement() {
      const saveData = {
        id: this.realEstate.id,
        contractAmountByAgreement: this.realEstate.contractAmountByAgreement,
        contractAmountByAgreementDescription: this.realEstate.contractAmountByAgreementDescription
      };
      this.$http.post('admin/new-real-estate-contract-amount-agreement', saveData)
          .then(res => {
            console.log(res);
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('messages.realEstate.success'),
              type: 'success'
            });
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },
    sendReportToMIBRealEstate: function () {
      this.processing = true;
      this.$http.get('/sendApiMibConfirmReport/pdf/' + this.realEstate.id + '/WITH_QR_CODE/Building', {responseType: 'arraybuffer'})
          .then(response => {
            if (response && response.status === 200) {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('realEstate.report.titleQrCode'),
                type: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.common.error'),
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    getCoordination() {
      return this.$http.get('admin/new-real-estate/coordination/' + this.realEstate.id);
    },
    changeStatus(status) {
      if (status === 'Evaluated') {
        this.getCoordination().then((res) => {
          const coordination = res.data.coordination;
          let errorTxt = '';
          if (this.realEstate.approachCost && coordination.expense.amount === 0) {
            errorTxt = "Харажат"
          }
          if (this.realEstate.approachIncome && coordination.income.amount === 0) {
            if (errorTxt.length > 0) errorTxt += ', ';
            errorTxt += "Даромад"
          }
          if (this.realEstate.approachComparative && coordination.comparison.amount === 0) {
            if (errorTxt.length > 0) errorTxt += ', ';
            errorTxt += "Киёсий"
          }

          if (errorTxt.length > 0) {
            errorTxt += " хисоб-китоб килинмаган!";
            this.$swal({
              title: this.$root.$t('messages.common.warning'),
              text: errorTxt,
              type: 'warning'
            });
          } else this.$router.push({
            path: '/new-real-estate/coordination/' + this.realEstate.id + '/' + true,
            query: {isEdit: true}
          });
        }).catch(({response}) => {
          this.$swal({
            type: 'error',
            title: '',
            text: response.data.message ? response.data.message : response.data
          });
          this.processing = false;
        });

      } else if (status === 'NotReady') {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.changeStatusGo(status);
      } else this.changeStatusGo(status);
    },
    changeStatusGo(status) {
      const vm = this;
      this.processing = true;
      this.$http.post('admin/new-real-estate/status', {
        realEstateId: this.realEstate.id,
        status: status,
        type: 'BASIC'
      }).then(res => {
        if (res && res.data && res.data.status === 'SUCCESS') {
          this.$swal({
            title: this.$root.$t('messages.common.success'),
            text: this.$root.$t('messages.realEstate.statusSuccess'),
            type: 'success'
          });
          vm.realEstate.status = status;
          vm.status = status;

          if (status === 'Confirmed') {
            if (this.realEstate.hasEsp) {
              /* this.$router.push({
                                    path: '/new-real-estate/esp/' + this.realEstate.id,
                                    query: {version: 'V2'}
                                }); */
              this.onSignDirectorEsp()
            }
          }
          // } else if (status === 'NotReady') {
          //     this.$router.push('/new-real-estate/' + this.realEstate.category);
          // }

          // this.$router.go(0);
          this.init()
          /* if (this.realEstate.category === 'Residential') {
                            this.$router.push('/new-real-estate/residential');
                        } else {
                            this.$router.push('/new-real-estate/notorious');
                        } */
        } else {
          this.$swal({
            title: this.$root.$t('messages.common.warning'),
            text: this.$root.$t('messages.realEstate.statusWarning'),
            type: 'warning'
          });
        }
        this.processing = false;
      }).catch(({response}) => {
        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });
        this.processing = false;
      });
    },
    showDeleteBuildingDialog(building, index) {
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('messages.building.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
        // cancelButtonColor: '#dd3333'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('new-real-estate/building/' + building.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('messages.building.deleteSuccess'),
                    type: 'success'
                  });
                  this.realEstate.buildings.splice(index, 1);
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.building.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        }
      });
    },
    isGoalType(goalTypeCodes) {
      return !!(this.realEstate.evlGoalType && goalTypeCodes && goalTypeCodes.indexOf(this.realEstate.evlGoalType) >= 0);
    },
    onProvinceChange() {
      if (this.realEstate.province.id > 0) {
        if (this.regions.length > 0) {
          this.realEstate.region = {}
        }
        this.initLandCapitalizationProvinceChangeData();
      }
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCustomerSearch(searchTxt, loading) {
      loading(true);
      this.customers = [];
      this.customerFilter.search = searchTxt;
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onCustomerFocus() {
      this.customers = [];
      this.customerFilter.search = '';
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    isEvlApproachConfirm() {
      return (this.realEstate.approachCost && (this.realEstate.approachComparative || this.realEstate.approachIncome));
    },
    reportPdf: function (realEstate) {

      this.isPdfLoading = true;

      // if (!this.isEvlApproachConfirm()) {
      //     this.isPdfLoading = false;
      //     return;
      // }

      this.$http.get('/v2/realEstateReport/pdf/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Хисобот ' + realEstate.owner.fullName + '.pdf';
            link.click();
            this.isPdfLoading = false
          })
          .catch(err => {
            console.log(err);
            this.isPdfLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportPdf(realEstate))
            }
          })
    },
    reportPdfQrCode: function (realEstate) {
      this.isPdfQrLoading = true;

      // if (!this.isEvlApproachConfirm()) {
      //     this.isPdfQrLoading = false;
      //     return;
      // }

      this.$http.get('/v2/realEstateReport/pdf/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Хисобот ' + realEstate.owner.fullName + '.pdf';
            link.click();
            this.isPdfQrLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isPdfQrLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportPdfQrCode(realEstate))
            }
          })
    },
    reportDoc: function (realEstate) {

      this.isDocLoading = true;

      // if (!this.isEvlApproachConfirm()) {
      //     this.isDocLoading = false;
      //     return;
      // }

      this.$http.get('/v2/realEstateReport/doc/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/doc'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Хисобот ' + realEstate.owner.fullName + '.doc';
            link.click();
            this.isDocLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isDocLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportDoc(realEstate))
            }
          })
    },
    reportDocQrCode: function (realEstate) {

      this.isDocQrLoading = true;

      // if (!this.isEvlApproachConfirm()) {
      //     this.isDocQrLoading = false;
      //     return;
      // }

      this.$http.get('/v2/realEstateReport/doc/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
          .then(response => {

            let blob = new Blob([response.data], {type: 'application/doc'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Хисобот ' + realEstate.owner.fullName + '.doc';
            link.click();
            this.isDocQrLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isDocQrLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportDocQrCode(realEstate))
            }
          })
    },
    reportContractDocQrCode: function (realEstate) {

      this.isCDocQrLoading = true;

      this.$http.get('/v2/realEstateContractReport/doc/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/doc'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Шартнома ' + realEstate.owner.fullName + '.doc';
            link.click();
            this.isCDocQrLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isCDocQrLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportContractDocQrCode(realEstate))
            }
          })
    },
    reportContractDoc: function (realEstate) {

      this.isCDocLoading = true;

      this.$http.get('/v2/realEstateContractReport/doc/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/doc'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Шартнома ' + realEstate.owner.fullName + '.doc';
            link.click();
            this.isCDocLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isCDocLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportContractDoc(realEstate))
            }
          })
    },
    reportContractPdf: function (realEstate) {
      this.isCPdfLoading = true;

      this.$http.get('/v2/realEstateContractReport/pdf/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Шартнома ' + realEstate.owner.fullName + '.pdf';
            link.click();
            this.isCPdfLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isCPdfLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportContractPdf(realEstate))
            }
          })
    },
    reportContractQrCodePdf: function (realEstate) {
      this.isCPdfQrLoading = true;

      this.$http.get('/v2/realEstateContractReport/pdf/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Шартнома ' + realEstate.owner.fullName + '.pdf';
            link.click();
            this.isCPdfQrLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isCPdfQrLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportContractQrCodePdf(realEstate))
            }
          })
    },
    reportNotSignedAndNoQrCodesPdf: function (realEstate) {
      this.isOtherPdfLoading = true;

      this.$http.get('/v2/realEstateReportNotSignedAndNoQrCodes/pdf/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/pdf'});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Хисобот ' + realEstate.owner.fullName + '.pdf';
            link.click();
            this.isOtherPdfLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.isOtherPdfLoading = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.reportNotSignedAndNoQrCodesPdf(realEstate))
            }
          })
    },
    showReport: function () {
      this.$http.post('admin/real-estate/show-report/' + this.realEstate.id + '/' + this.realEstate.displayReport)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.showReportSuccess'),
                type: 'success'
              });
              this.realEstate.status = status;
            } else if (res && res.data && res.data.status === 'FAIL') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                type: 'success'
              });
            }
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.showReportError'),
              type: 'error'
            });
          });
    },
    handleChangeLand: function (e) {
      const name = e.target.name;
      if (this.realEstate[name]) {
        Object.keys(this.realEstate).map((key) => {
          if (key != name) {
            if (key === 'landComparisonEnabled' || key === 'landCapitalizationEnabled' || key === 'landLeaseEnabled') {
              this.realEstate[key] = false;
            }
          }
        })
      }
      if (this.realEstate.landCapitalizationEnabled) {
        this.initLandCapitalizationRegionChangeData();
      }
    },
    onRegionChange() {
      if (this.realEstate.region.id > 0) {
        // this.onMicroRegionFocus();
        this.initLandCapitalizationRegionChangeData();
      }
    },
    initLandCapitalizationProvinceChangeData() {
      const vm = this;
      this.$http.get('admin/new-real-estate/land-capitalization/province/' + this.realEstate.province.id)
          .then(res => {
            const data = res.data;
            vm.initLandCapitalizationData(data)
          }, err => {
            console.log(err);
          });
    },
    async initLandCapitalizationRegionChangeData() {
      const vm = this;
      await this.$http.get('admin/new-real-estate/land-capitalization/region/' + this.realEstate.region.id)
          .then(res => {
            const data = res.data;
            vm.initLandCapitalizationData(data)
          }, err => {
            console.log(err);
          });
    },
    initLandCapitalizationData(data) {
      this.financingRate = data.financingRate;
      this.taxPerHectare = data.taxPerHectare;
    },
    calculateApproachTotal(building) {
      let approachTotalPrice = 0;
      if (building.calculated && building.calculated.price && building.calculated.price.expense && this.realEstate.approachCost) {
        approachTotalPrice = approachTotalPrice + building.calculated.price.expense;
      }
      if (building.comparison && building.comparison.calculatedTotalPrice && this.realEstate.approachComparative) {
        approachTotalPrice = approachTotalPrice + building.comparison.calculatedTotalPrice;
      }
      if (building.comparisonIncome && building.comparisonIncome.calculated && building.comparisonIncome.calculated.total && this.realEstate.approachIncome) {
        approachTotalPrice = approachTotalPrice + building.comparisonIncome.calculated.total;
      }
      if (building.comparisonRegression && building.comparisonRegression.totalPrice && this.realEstate.approachRegression) {
        approachTotalPrice = approachTotalPrice + building.comparisonRegression.totalPrice;
      }
      return approachTotalPrice;
    },
    onBuildingFocus() {
      if (!this.buildingTypes.length && this.canShowForAllSpecialUsers) {
          this.$http.post('building-type/list', {search: '', onlyParentLookUp: true})
              .then(res => {
                  if (res.data !== "" && res.data.data.length > 0) {
                      this.buildingTypes = res.data.data;
                  }
              }, err => {
                  console.log(err);
              });
      }
    },
    onBuildingTypeSearch(searchTxt, loading) {
      if(this.canShowForAllSpecialUsers) {
        loading(true);
        this.filterBuildingType.parent = null
        this.filterBuildingType.search = searchTxt;
        this.filterBuildingType.onlyParentLookUp = true

        this.$http.post('building-type/list', this.filterBuildingType)
            .then(res => {
              if (res.data !== "" && res.data.data.length > 0) {
                this.buildingTypes = res.data.data;
              }
              loading(false);
            }, err => {
              console.log(err);
            });
      }
    },
    onRepairFocus() {
      this.repairConditions = [];
      this.$http.get('uy-joy-api/repair-conditions')
          .then(res => {
            this.repairConditions = res.data;
          }, err => {
            console.log(err)
          })
    },
    onRepairChange() {
      // if (this.realEstate.evlGoalType !== 'Losses') {
      //     this.realEstate.approachIncome = true;
      // }
      if (this.repairCondition && this.repairCondition.code === 'wreckage') {
        this.realEstate.approachIncome = false;
      }
    },
    subBuildingTypeFocus() {
        if (!this.subBuildingTypes.length && this.buildingType) {
            this.filterBuildingType.cadastreType = this.realEstate.category
            this.filterBuildingType.parent = this.buildingType.id
            this.filterBuildingType.onlyParentLookUp = false

            this.$http.post('building-type/list', this.filterBuildingType)
                .then(res => {
                    if (res.data !== "" && res.data.data.length > 0) {
                        this.subBuildingTypes = res.data.data;
                    }
                }, err => {
                    console.log(err);
                });
        }
    },
    subBuildingTypeSearch(searchTxt, loading) {
      if(this.canChangeSubBuildingType) {
        loading(true);
        this.filterBuildingType.cadastreType = this.realEstate.category
        this.filterBuildingType.parent = this.buildingType.id
        this.filterBuildingType.onlyParentLookUp = false
        this.filterBuildingType.search = searchTxt;

        this.$http.post('building-type/list', this.filterBuildingType)
            .then(res => {
              if (res.data !== "" && res.data.data.length > 0) {
                this.subBuildingTypes = res.data.data;
              }
              loading(false);
            }, err => {
              console.log(err);
            });
      }
    },
    onChangeBuildingType() {
      if(this.isUserSpecial) {
        this.subBuildingTypes = []
        this.subBuildingType = null

        if (this.buildingType && this.buildingType.id > 0) {
          if (this.buildingType.code === 'RESIDENTIAL_MULTI_STOREY') {
            this.realEstate.separateBuilding = false;
          }
          this.purposeRentingAreas = [];
          this.$http.get('rental-rates/purposes-renting-areas/tree-lookup/' + this.buildingType.code)
              .then(res => {
                this.purposeRentingAreas = res.data;
              }, err => {
                console.log(err);
              });
        }
      }
    },
    initBuildingType() {
      const vm = this;
      this.filterBuildingType.cadastreType = this.realEstate.category
      this.filterBuildingType.onlyParentLookUp = true
      this.$http.post('building-type/list', this.filterBuildingType)
          .then(res => {
            if (res.data !== "" && res.data.data.length > 0) {
              vm.buildingTypes = res.data.data;
              const buildingTypes = vm.buildingTypes.filter(b => b.code === vm.realEstate.buildingType);
              vm.buildingType = buildingTypes[0];
              if (vm.realEstate.subBuildingType) {
                  vm.initSubBuildingType()
              } else {
                this.canChangeSubBuildingType = true;
              }
            }
          }, err => {
            console.log(err);
          });
    },
    initSubBuildingType() {
        const vm = this;
        this.filterBuildingType.cadastreType = this.realEstate.category
        this.filterBuildingType.parent = this.buildingType.id
        this.filterBuildingType.onlyParentLookUp = false

        this.$http.post('building-type/list', this.filterBuildingType)
            .then(res => {
                if (res.data !== "" && res.data.data.length > 0) {
                    this.subBuildingTypes = res.data.data;
                    const subBuildingTypes = vm.subBuildingTypes.filter(b => b.code === vm.realEstate.subBuildingType);
                    vm.subBuildingType = subBuildingTypes[0];
                    this.canChangeSubBuildingType = vm.subBuildingType.name ? vm.subBuildingType.name.toLowerCase() === "бошқалар" : false;
                }
            }, err => {
                console.log(err);
            });
    },
    initRepair() {
      this.repairConditions = [];
      const vm = this;
      this.$http.get('uy-joy-api/repair-conditions')
          .then(res => {
            vm.repairConditions = res.data;
            const repairConditions = vm.repairConditions.filter(r => r.code === vm.realEstate.repairCondition);
            vm.repairCondition = repairConditions[0];
          }, err => {
            console.log(err)
          })
    },
    onConstructiveElementFocus() {
      const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
      this.$http.get(url)
          .then(res => {
            this.walls = res.data;
          }, err => {
            console.log(err);
          });
    },
    initConstructiveElement() {
      const vm = this;
      const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
      this.$http.get(url)
          .then(res => {
            this.walls = res.data;
            const walls = vm.walls.filter(w => w.code === vm.realEstate.wall);
            vm.wall = walls[0];
          }, err => {
            console.log(err);
          });
    },
    initSpecialComfort() {
      this.specialComforts = [];
      const vm = this;
      this.$http.get('admin/new-real-estate/special-comports')
          .then(res => {
            if (res.data && res.data.length > 0) {
              vm.specialComforts = res.data;
              const specialComforts = vm.specialComforts.filter(s => s.code === vm.realEstate.specialComfort);
              vm.specialComfort = specialComforts[0]
            }
          }, err => {
            console.log(err);
          });
    },
    initArchitecturalStyle() {
      this.architecturalStyles = [];
      const vm = this;
      this.$http.get('admin/new-real-estate/architectural-styles')
          .then(res => {
            if (res.data && res.data.length > 0) {
              vm.architecturalStyles = res.data;
              const architecturalStyle = vm.architecturalStyles.filter(a => a.code === vm.realEstate.architecturalStyle);
              vm.architecturalStyle = architecturalStyle[0]
            }
          }, err => {
            console.log(err)
          })
    },
    onChangeStorey(val) {
      if (val > 0 && val < 2) {
        this.realEstate.floor = val
      }
    },
    subBuildingIncomeTotal(income) {
      if (income && income.calculated && income.calculated.total) {
        return income.calculated.total;
      }
      return 0;
    },
    getEvaluationRespectiveType() {
      this.$http.get('/evaluationRespectiveType').then(response => {
        this.evaluationRespectiveTypes = response.data;
      }, err => {
        console.log(err)
      });
    },
    onSpecialComfortFocus() {
      this.specialComforts = [];
      this.$http.get('admin/new-real-estate/special-comports')
          .then(res => {
            if (res.data && res.data.length > 0) {
              this.specialComforts = res.data;
            }
          }, err => {
            console.log(err);
          });
    },
    onArchitecturalStyleFocus() {
      this.architecturalStyles = [];
      this.$http.get("admin/new-real-estate/architectural-styles")
          .then(res => {
            if (res.data && res.data.length > 0) {
              this.architecturalStyles = res.data;
            }
          }, err => {
            console.log(err);
          });
    },
    isLeftCustomField(field) {
        return field && field.alignment === 1 && this.hasField(field.code);
    },
    isRightCustomField(field) {
        return field && field.alignment === 2 && this.hasField(field.code);
    },
    getReferenceById(code, id) {
      if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
        const fieldReferences = this.cadastreBuildingFieldReferences[code];
        const references = fieldReferences.filter((ref) => {
          return ref.id === id
        });
        return references.length > 0 ? references[0] : null;
      } else {
        return null;
      }
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionSearch(searchTxt, loading) {
      loading(true);
      this.regions = [];
      this.filterRegion.search = searchTxt;
      this.filterRegion.provinceId = (this.realEstate.province && this.realEstate.province.id) ? this.realEstate.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionFocus() {
      this.regions = [];
      this.filterRegion.provinceId = (this.realEstate.province && this.realEstate.province.id) ? this.realEstate.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onMicroRegionFocus() {
      this.microRegions = [];
      this.filterMicroRegion.region = (this.realEstate.region && this.realEstate.region.id) ? this.realEstate.region.id : 0;
      this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
          .then(res => {
            this.microRegions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    getProvince(result) {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            let province = this.provinces.filter(p => p.code === result.province.code)[0];
            if (province && province.id) {
              this.realEstate.province = province;
              this.getRegion(result)
            }
          }, err => {
            console.log(err);
          });
    },
    getRegion(result) {
      this.regions = [];
      this.filterRegion.provinceId = (this.realEstate.province && this.realEstate.province.id) ? this.realEstate.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            let region = this.regions.filter(r => r.code === result.region.code)[0]
            if (region && region.id && region.id > 0) {
              this.realEstate.region = region;
              this.onRegionChange()
            }
          }, err => {
            console.log(err);
          });
    },
    mfyFocus() {
        this.mfyList = [];
        if (!this.realEstate.mfy) {
            this.filterMfy.search = '';
        }

        this.filterMfy.code = (this.realEstate.region && this.realEstate.region.code) ? this.realEstate.region.code : "";
        this.$http.post('/mfy/search', this.filterMfy)
            .then(res => {
                this.mfyList = res.data.data;
            }, err => {
                console.log(err);
            });
    },
    mfySearch(searchTxt, loading) {
        loading(true);
        this.mfyList = [];
        this.filterMfy.search = searchTxt;
        this.filterMfy.code = (this.realEstate.region && this.realEstate.region.code) ? this.realEstate.region.code : "";
        this.$http.post('/mfy/search', this.filterMfy)
            .then(res => {
                this.mfyList = res.data.data;
                loading(false);
            }, err => {
                console.log(err);
            });
    },
    onMfyChange() {
      this.microRegions = [];
      if (this.realEstate.mfy) {
        this.$http.get(`/micro-regions/by-mfy/${this.realEstate.mfy.mfyId}`)
            .then(res => {
              this.microRegions = res.data;
            }, err => {
              console.log(err);
            });
      }
    },
    viewRealEstateAct(id) {
      this.$eventBus.$emit('showBuildingActModal', id);
    },
    viewRealEstateSurvey(realEstate) {
      this.$eventBus.$emit('showBuildingSurveyModal', realEstate)
    },
    showBindAgentModal() {
      this.$eventBus.$emit('showRealEstateBindAgentModal', this.realEstate);
    },
    searchOldEvalautionWork() {
      this.$http.get(`admin/new-real-estate/old-evaluation-works/${this.realEstate.id}`)
          .then(res => {
            if (res.data) {
              this.oldEvaluationWorks = res.data;
            }
          }, err => {
            console.log(err);
          })
    },
    searchRealEstateComparativeEvaluated(requestFilter) {
      this.processing = true
      const vm = this;

      this.$http.post('admin/v3/real-estate/search-comparative-evaluated', requestFilter)
          .then(res => {
            if (res && res.data && res.data.code !== 'NOT_FOUND') {
              const searchingData = res.data // parseToData(res.data, this.cadastreBuildingFields, this.cadastreBuildingFieldReferences);
              // console.log('searchingData = ', searchingData)

              const editRealEstateData =  JSON.parse(JSON.stringify(this.realEstate.data));
              const resultRealEstateData = JSON.parse(JSON.stringify(searchingData.data));

              const data = updateDifferences2(editRealEstateData, resultRealEstateData)

              let realEstate = JSON.parse(JSON.stringify(this.realEstate))

              // console.log('search-comparative-evaluated = ', data)
              realEstate.data = data
              // realEstate.name = searchingData.name
              realEstate.architecturalStyle = searchingData.architecturalStyle
              // realEstate.specialComfort = searchingData.specialComfort
              // realEstate.evlPropertyType = searchingData.evlPropertyType
              // realEstate.repairCondition = searchingData.repairCondition
              // realEstate.sectionId = searchingData.sectionId

              /* if (searchingData.mfy) {
                realEstate.mfy = searchingData.mfy
              } */

              // realEstate.microRegionId = searchingData.microRegionId
              // realEstate.subBuildingType = searchingData.subBuildingType
              // realEstate.buildingType = searchingData.buildingType
              // realEstate.isMicroRegionSelected = searchingData.isMicroRegionSelected
              // realEstate.separateBuilding = searchingData.separateBuilding

              vm.architecturalStyle = searchingData.architecturalStyleDto
              // vm.specialComfort = searchingData.specialComfortDto
              if (searchingData.wall) {
                const walls = vm.walls.filter(w => w.code === searchingData.wall);
                vm.wall = walls[0];
              }

              // vm.repairCondition = searchingData.repairConditionDto

             /* if (searchingData.buildingType) {
                vm.initBuildingType()
              }
              if (searchingData.microRegionId) {
                vm.onMfyChange()
              } */

              // console.log('this.realEstate.data1 = ', JSON.parse(JSON.stringify(this.realEstate.data)))
              // console.log('this.cadastreBuildingFields1 = ', JSON.parse(JSON.stringify(this.cadastreBuildingFields)))

              this.cadastreBuildingFields = JSON.parse(JSON.stringify(this.cadastreBuildingFieldsClone))
              this.realEstate = parseToData(realEstate, this.cadastreBuildingFields, this.cadastreBuildingFieldReferences);

              // console.log('this.realEstate.data2 = ', JSON.parse(JSON.stringify(this.realEstate.data)))
              // console.log('this.cadastreBuildingFields2 = ', JSON.parse(JSON.stringify(this.cadastreBuildingFields)))
            }

            this.processing = false;

          }).catch((response) => {
          console.log('error', response)
          this.processing = false;
      })
    },
    onSignDirectorEsp() {
      this.$http.get(`esign/director/${this.realEstate.id}/Building`)
          .then(res => {
            if (res.data && res.data.status === 'SUCCESS') {
              // console.log("onSignDirectorEsp re.data = ", res.data)
              window.open(res.data.data, '_blank');
            } else {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: res.data.message,
                type: 'warning'
              });
            }
          }, err => {
            console.log(err);
          })
    },
    onSignAppraisalEsp() {
      this.$http.get(`esign/appraiser/${this.realEstate.id}/Building`)
          .then(res => {
            if (res.data && res.data.status === 'SUCCESS') {
              // console.log("onSignAppraisalEsp re.data = ", res.data)
              window.open(res.data.data, '_blank');
            } else {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: res.data.message,
                type: 'warning'
              });
            }
          }, err => {
            console.log(err);
          });
    },
    sendMessageFromAndroid() {
      const username = this.$store.state.profile.username
      this.onEditFireBase(username)
    },
    onEditFireBase(username) {
      let dbRef = fireBaseDb.collection("users")
      let isDataAvailable = false
      dbRef.where("username", "==", username).get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data()) {
                console.log('firebase edit =', doc.data())
                if (doc.data().web_status === 'DEACTIVATED') {
                  this.onUpdateFireBase(doc.id)
                }
                isDataAvailable = true
              }
            });
            if (!isDataAvailable) {
              this.onWriteFireBase(username)
            }
          }).catch((error) => {
        console.log(error);
      });
    },
    onUpdateFireBase(key) {
      fireBaseDb.collection("users").doc(key)
          .update({web_status: "ACTIVE", evlType: 'REAL_ESTATE', source: "INSIDE"})
          .then(() => {
            console.log("FireBase successfully updated!");
            this.loadFireBase = true;
            this.onFireBaseSnapshotChange(key)
          })
          .catch((error) => {
            console.log(error);
          });
    },
    onWriteFireBase(username) {
      this.fireBaseRequest.username = username;
      this.fireBaseRequest.web_status = 'ACTIVE'
      this.fireBaseRequest.android_status = 'DEACTIVATED'

      console.log('firebase request = ', this.fireBaseRequest)
      fireBaseDb.collection("users")
          .add(this.fireBaseRequest)
          .then((res) => {
            this.loadFireBase = true;
            console.log("FireBase successfully created!", res.id)
            this.fireBaseRequest.key = res.id;
            this.onShowAlert('success', 'Ҳужжатни сканерлаш учун хабар мобил иловага юборилди! Илтимос мобил иловага киринг!');

            this.onFireBaseSnapshotChange(res.id)
          }).catch((err) => {
        console.log(err);
      })
    },
    onFireBaseSnapshotChange(key) {
      let dbRef = fireBaseDb.collection("users").doc(key)
      dbRef.onSnapshot((doc) => {
        console.log('firebase res id', doc.id)
        console.log('firebase res', doc.data())

        const username = this.$store.state.profile.username;
        let isActiveWeb = doc && doc.data() && doc.data().username === username && doc.data().web_status === 'ACTIVE';
        if (isActiveWeb && doc.data().android_status === 'ACTIVE') {
          this.onShowAlert('warning', 'Ҳужжатни сканерлаш жараёнида!')
        } else if (isActiveWeb && doc.data().android_status !== 'ACTIVE') {
          this.onShowAlert('error', 'Илтимос мобил иловага киринг! Ҳужжатни сканерланг!')
        }

      })
    },
    onShowAlert(type, message) {
      this.$swal({
        position: 'top-end',
        type: type,
        text: message,
        showConfirmButton: false,
        timer: 3000
      });
    },
    onFieldValueChange(field) {
      if (field && !this.isLeftFieldDisabled(field.code)) {
        let fieldValue = {};
        if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
          if (field.type === 'LISTBOX') {
            field.selected = this.getReferenceById(field.reference.code, field.value);
          }
          if (field.selected) {
            fieldValue = {
              id: field.selected.id,
              code: field.selected.code
            }
          }
          if (field.type === 'COMBOBOX') {
            field.value = fieldValue;
          }
        } else if (field.type === 'MULTISELECT') {
          fieldValue = [];
          if (field.selected && field.selected.length > 0) {
            field.selected.forEach((ref_id) => {
              const ref = this.getReferenceById(field.reference.code, ref_id);
              if (ref) {
                fieldValue.push({
                  id: ref.id,
                  code: ref.code
                })
              }
            });
          }
          field.value = fieldValue;
        } else {
          fieldValue = field.value;
        }

        this.realEstate.data.values[field.code] = fieldValue;

        if (field.reference) {
            const ref = this.getReferenceById(field.reference.code, fieldValue.id);
            if (ref && ref.data && ref.data.values) {
                if (ref.data.values['LAND_OWNER_RIGHT_TYPE']) {
                    let landType = ref.data.values['LAND_OWNER_RIGHT_TYPE'];
                    landType.forEach((landKey) => {
                        this.realEstate[landKey] = true
                    })

                    Object.keys(this.realEstate).map((key) => {
                        if (!landType.includes(key)) {
                            if (key === 'landComparisonEnabled' || key === 'landCapitalizationEnabled'
                                || key === 'landLeaseEnabled' || key === 'landOwnerEnabled') {
                                this.realEstate[key] = false;
                            }
                        }
                    })
                }
            }
        }
      }
    },
    // hasField(code) {
    //     const fields = this.formFields.fields.filter((field) => {
    //         return field !== 'land_owner_right' && field !== 'non_market_type'
    //     })
    //
    //     if (this.isResidential) {
    //       return fields.filter((field) => {
    //         return field !== 'elevator'
    //       }).includes(code)
    //     }
    //
    //     if ((this.isMultiStorey || this.isResidential)) {
    //       return fields.filter((field) => {
    //         return field !== 'basement_building_type'
    //       }).includes(code)
    //     }
    //
    //   return fields.includes(code)
    // },
    hasField(code) {
      const excluded = new Set([
        'land_owner_right',
        'non_market_type',
        'land_fund_category',
        ...(this.isResidential ? ['elevator'] : []),
        ...((this.isMultiStorey || this.isResidential)
            ? ['basement_building_type']
            : [])
      ]);

      return !excluded.has(code) && this.fieldSet.has(code);
    },
    getReferenceByCode(code, childCode) {
      if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
        const fieldReferences = this.cadastreBuildingFieldReferences[code];
        const references = fieldReferences.filter((ref) => {
          return ref.code === childCode
        });
        return references.length > 0 ? references[0] : null;
      } else {
        return null;
      }
    },
    setAndroidReceiveData(key) {
      this.formFields.fields.forEach((f) => {
        let bField = this.cadastreBuildingFields.filter((c) => c.code === f);
        const rField = bField.length > 0 ? bField[0] : null
        if (rField && this.getReferenceByCode(rField.reference.code, key)) {
          const field = this.getReferenceByCode(rField.reference.code, key);
          rField.value = field.id
          rField.selected = {
            id: field.id,
            code: field.code
          }
          this.onFieldValueChange(rField)
        }
      })
    },
    onChangeConstructionCompletion() {
      if (this.realEstate.constructionCompletion < 100 || this.hasTotalArea) {
        this.minValueUsefulArea = 0
      } else {
        this.minValueUsefulArea = 0.01
      }
    },
    async handleDownloadImage(imageUrl, imageName = "Image") {
      if(imageUrl) {
        const response = await fetch(imageUrl);
        const blobImage = await response.blob();
        const href = URL.createObjectURL(blobImage);
        const anchorElement = document.createElement('a');
        anchorElement.href = href;
        anchorElement.download = imageName || "Image";
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
      }
    },
    sendFixError() {
      this.$http.post('cadastre-historical/sender-source-count',{ cadastreNumber: this.realEstate.cadastreDocNumber ,senderSource: 'EVALUATOR', uuid: this.realEstate.uuid })
          .then(res => {
            if (res.data < 1) {
              this.$eventBus.$emit('showCadastreFixErrorModal');
            } else {
              this.$swal({
                type: 'warning',
                title: '',
                text: 'Сиз аввал камчилик юборгансиз'
              });
            }
          }, err => {
            console.log(err);
          });
    },
    getFixError() {
      this.processing = true;
      this.$http.get('v3/real-estate/get-fix-error/' + this.realEstate.uuid)
          .then(async res => {
            let resData = res.data;
            this.processing = false;
            if (resData.status === 'SUCCESS' && resData.data) {
              let status = "ЯНГИ"
              let type = 'info'
              if (resData.data.processStatus === 'DONE') {
                status = this.$t("realEstate.status.confirmed")
                type = 'success'

                let responseFixError = resData.data;
                responseFixError.requestId = this.realEstate.requestId

                await this.saveFixError(responseFixError)

              } else if (resData.data.processStatus === 'IN_PROGRESS') {
                status = this.$t("realEstate.status.notFullyEvaluated")
              } else if (resData.data.processStatus === 'REJECT') {
                status = this.$t("realEstate.status.rejected")
                type = 'warning'
              }

              this.$swal({
                title: this.$t('messages.common.success'),
                text: status,
                type: type
              });
            }
          }).catch(({response}) => {
        console.log('error')
        console.log(response)

        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });

        this.processing = false;
      })
    },
    saveFixError(responseFixError) {
      this.processing = true;
      this.$http.post('v3/real-estate/save-fix-error', responseFixError)
          .then(res => {
            console.log(res)
            this.processing = false;

            if (this.realEstate.category === 'Residential') {
              this.$router.push('/new-real-estate-plus/residential');
            } else {
              this.$router.push('/new-real-estate-plus/notorious');
            }

          }).catch(({response}) => {
            console.log('error')
            if (response.data && response.data.code === "NOT_COMPLETED") {
              this.$eventBus.$emit('showConstructionCompletionPercentageModal');
              return
            }
            this.$swal({
              type: 'error',
              title: '',
              text: response.data.message ? response.data.message : response.data
            });
            this.processing = false;
      })
    },
    onUpdateValues() {
      this.processing = true;
      this.$http.get('v3/real-estate/update-values/' + this.realEstate.id)
          .then(async res => {
            let resData = res.data;
            console.log("resData = ", resData)
            this.processing = false;
            this.$swal({
              type: 'success',
              title: this.$t('messages.common.success'),
            });
          }).catch(({response}) => {
        console.log('error')
        console.log(response)

        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });

        this.processing = false;
      })
    },
    handleCompletionData(data) {
      this.processing = true;
      this.$http.get(`admin/v3/real-estate/${this.realEstate.requestId}`)
          .then(res => {
            const editData = res.data;
            editData.constructionCompletion = data.constructionCompletion
            editData.constructionCompletionDoc = data.constructionCompletionDoc

            this.saveRealEstatePlus(editData)
            this.processing = false;
          }, () => {
            this.processing = false;
          })
    },
    saveRealEstatePlus(realEstate) {
      this.processing = true;
      this.$http.post('admin/v3/real-estate/save', realEstate)
          .then(res => {
            if (res.status === 200 && res.data) {
              this.cancel()
            }
            this.processing = false;

          }).catch(({response}) => {
        console.log('error')
        console.log(response)

        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });

        this.processing = false;
      })
    },
    findingComparativeErrors(realEstateId) {
      this.processing = true;
      this.$http.get('admin/new-real-estate/finding-comparative-errors/' + realEstateId,)
          .then(res => {
            console.log(res)
            this.processing = false;

          }).catch(({response}) => {
          console.log('error')
          console.log(response)

          this.$swal({
            type: 'error',
            title: '',
            text: response.data.message ? response.data.message : response.data
          });

        this.processing = false;
      })
    },
    isLeftFieldDisabled(fieldCode) {
      return this.isUserSpecial ? !this.enabledFieldsForSpecialUser.includes(fieldCode) : this.isUserDirector ? this.disabledFieldsForDirector.includes(fieldCode) : this.disabledFields.includes(fieldCode);
    },
    isRightFieldDisabled(fieldCode) {
      return this.isUserSpecial ? !this.enabledFieldsForSpecialUser.includes(fieldCode) : false;
    },
    showFieldForSpecialUser(fieldCode) {
      return this.isUserSpecial
          ? !this.hiddenFieldsForSpecialUser.includes(fieldCode)
          : this.isUserSpecial2
              ? !this.hiddenFieldsForSpecialUser2.includes(fieldCode)
              : true;
    },
    handleChangeMicroRegionSelected(event) {
      if(event.target) {
        if(event.target.checked) {
          this.onMfyChange();
        } else {
          this.realEstate.microRegionId = null;
        }
      }
    },
    canShowFieldInMultiStoreyForSpecialUSer(fieldCode) {
      return this.canShowForAllSpecialUsers && fieldCode && this.isMultiStorey ? !this.hiddenMultiStoreyFields.includes(fieldCode) : true
    }
  },
  created() {
    this.cadastreSectionFilter.page.size = 10000;
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.filterMicroRegion.pageFilter.size = 10000;
    this.filterBuildingType.cadastreType = this.realEstate.category
    this.init();
    this.getEvaluationRespectiveType();

    this.$eventBus.$on('receiveForRealEstateDataFromAndroid', (data) => {
      if (data) {

        this.onShowAlert('success', 'Ҳужжатни сканерлаш якунланди!')

        this.loadFireBase = false;
        this.realEstate.cadastreDocNumber = data.cadastreDocNumber
        this.realEstate.evlGroundArea = data.evlGroundArea
        this.realEstate.evlBuildingWidthArea = data.evlBuildingWidthArea
        this.realEstate.evlUsefulField = data.evlUsefulField
        this.realEstate.name = data.name
        this.realEstate.address = data.address
        if (data.category) {
          this.realEstate.category = data.category
        }
        if (data.typeOfRight) {
          this.setAndroidReceiveData(data.typeOfRight)
        }
      }
    })

    this.fieldSet = new Set(this.formFields.fields);
  },
  watch: {
    hasTotalArea : {
      handler: function (val) {
        if (val) {
          this.minEvlTotalArea = 0.01
          this.minValueUsefulArea = 0
        } else {
          this.minEvlTotalArea = 0
          this.minValueUsefulArea = 0.01
        }
      }
    }
  }
}
</script>

<style scoped>
.comparison-table th {
  /*vertical-align: top;*/
  border: 1px solid #dee2e6;
  border-collapse: collapse;
  background-color: #E9FAFD;
}

.comparison-table td {
  border: 1px solid #dee2e6;
  border-collapse: collapse;
}

.comparison-table .percentage {
  margin: auto;
  width: 110px !important;
  display: inline-block;
}

.comparison-table .percentage div {
  width: 80px !important;
  float: left;
}

.comparison-table .percentage span {
  display: block;
  margin: 7px 5px;
  float: left;
}

.comparison-table .section-start td {
  background-color: #F3F3F3;
}

.comparison-table .section-start > td:first-child {
  font-weight: bold;
}

.alert-wrap {
  background: white;
  border-radius: 5px;
  color: black;
}

.alert-wrap a {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: #229EFF;
  font-size: 1rem;
}

.alert-item {
  font-size: 14px;
  color: gray;
}

.income-text {
  font-size: 14px;
  text-transform: none;
}

.colllapse-header {
  cursor: pointer;
}

</style>
